{
  "account.label": "Account",
  "admin.addAnswer": "Answer",
  "admin.addQuestion": "Add question",
  "admin.answerPlaceholder": "Answer option",
  "admin.collapseList": "Collapse list",
  "admin.confirmDeleteQ": "Delete questionnaire?",
  "admin.defaultPowerLabel": "Default power (optional)",
  "admin.expandList": "Show questionnaires",
  "admin.instructionsLabel": "Instructions (optional)",
  "admin.instructionsPlaceholder": "Hint for the person filling it out",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "e.g. Empathy check",
  "admin.newQuestionnaire": "+ New questionnaire",
  "admin.noQuestionnaires": "No questionnaires yet.",
  "admin.nonePlaceholder": "None",
  "admin.qTitle": "Questionnaires",
  "admin.questionPlaceholder": "Question / statement",
  "admin.removeAnswer": "Remove answer",
  "admin.removeQuestion": "Remove question",
  "admin.selectOrCreate": "Select a questionnaire on the left or create a new one.",
  "admin.selectPower": "Select power",
  "admin.statusActive": "Active",
  "admin.statusInactive": "Inactive",
  "admin.statusLabel": "Status",
  "admin.validationHint": "Name, plus text + power per question and text per answer required.",
  "admin.weightLabel": "Weight",
  "admin.yesDelete": "Yes, delete",
  "adminSettings.appearance.accentHint": "Accent · Buttons, highlights",
  "adminSettings.appearance.accentLabel": "Accent",
  "adminSettings.appearance.bgHint": "Base · Page",
  "adminSettings.appearance.bgLabel": "Background",
  "adminSettings.appearance.openPicker": "Open colour picker",
  "adminSettings.appearance.presetsFor": "Presets for {label}",
  "adminSettings.appearance.reset": "↺ Reset to default",
  "adminSettings.appearance.sub": "Background, surface and accent drive the app. Text is set to black or white automatically.",
  "adminSettings.appearance.surfaceHint": "Cards · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxes",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App name",
  "adminSettings.branding.appNameHint": "Shown top-left. Empty falls back to “smycles”.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.paletteNote": "The palette below applies live; unsaved changes appear in the save bar and persist platform-wide on save.",
  "adminSettings.branding.sub": "App name and colour palette. Applies platform-wide.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.hrPrompt.defaultActive": "The Genesis default is currently active.",
  "adminSettings.hrPrompt.hint": "The {{responseLanguage}} placeholder is replaced automatically. A match supplement comes last in the combined prompt and takes precedence on conflicts.",
  "adminSettings.hrPrompt.label": "Global HR base prompt",
  "adminSettings.hrPrompt.reset": "Use Genesis default",
  "adminSettings.hrPrompt.sub": "Central recruiter instruction for all review matches. Match-specific supplements are appended afterwards.",
  "adminSettings.hrPrompt.title": "HR prompt",
  "agent.back": "Back to chats",
  "agent.chatsEmpty": "No chats yet. Start a new one above.",
  "agent.chatsError": "Couldn't load chats.",
  "agent.chatsLoading": "Loading…",
  "agent.close": "Close",
  "agent.closeImage": "Close image",
  "agent.contextBreak": "New context window",
  "agent.deleteChat": "Delete chat",
  "agent.deleteMessage": "This conversation will be permanently deleted.",
  "agent.deleteTitle": "Delete chat?",
  "agent.empty": "Ask the assistant about people, profiles and more.",
  "agent.error": "Couldn't reach the assistant. Try again.",
  "agent.expandImage": "View full size",
  "agent.input": "Assistant input",
  "agent.jumpToLatest": "Jump to latest",
  "agent.newChat": "New chat",
  "agent.personInfo.heading": "Profile",
  "agent.personInfo.label": "Load full profile",
  "agent.placeholder": "Ask the assistant…",
  "agent.send": "Send",
  "agent.starters.growth.0": "What skills should I develop next?",
  "agent.starters.growth.1": "Which roles match my experience?",
  "agent.starters.growth.2": "Where can I grow from here?",
  "agent.starters.growth.3": "What experience am I missing for senior roles?",
  "agent.starters.growth.4": "Suggest a learning path for me",
  "agent.starters.growth.5": "Which skills are most in demand?",
  "agent.starters.growth.6": "What strengths can I build on?",
  "agent.starters.growth.7": "Compare my profile to a target role",
  "agent.starters.growth.8": "What gaps hold me back?",
  "agent.starters.growth.9": "Recommend next steps for my career",
  "agent.starters.match.0": "List my recent matches",
  "agent.starters.match.1": "What search options are there?",
  "agent.starters.match.2": "Show details of my latest match",
  "agent.starters.match.3": "Count my matches",
  "agent.starters.match.4": "Find a match by name",
  "agent.starters.match.5": "Which match did I update last?",
  "agent.starters.match.6": "Search for a person",
  "agent.starters.match.7": "Show my newest match's candidates",
  "agent.starters.match.8": "What can I search for?",
  "agent.starters.match.9": "List matches from this month",
  "agent.starters.save.0": "Show my profile",
  "agent.starters.save.1": "What skills are on my profile?",
  "agent.starters.save.2": "Which languages do I have?",
  "agent.starters.save.3": "What experience is on my profile?",
  "agent.starters.save.4": "Summarize my profile",
  "agent.starters.save.5": "What is my current job title?",
  "agent.starters.save.6": "List my education",
  "agent.starters.save.7": "Which companies have I worked at?",
  "agent.starters.save.8": "What's my strongest skill area?",
  "agent.starters.save.9": "Show my contact details",
  "agent.starters.share.0": "List my shared items",
  "agent.starters.share.1": "Show my most recent share",
  "agent.starters.share.2": "Summarize my shared projects",
  "agent.starters.share.3": "Show my public shares",
  "agent.starters.share.4": "Show my private shares",
  "agent.starters.share.5": "List what I shared this month",
  "agent.starters.share.6": "Show details of my latest share",
  "agent.starters.share.7": "Find a shared item by name",
  "agent.starters.share.8": "List items shared with my team",
  "agent.starters.share.9": "List my shared projects",
  "agent.starters.tobis.0": "Which films do we have in the Drama genre?",
  "agent.starters.tobis.1": "Find comparable films for this pitch's tonality",
  "agent.starters.tobis.2": "Search for an actor or director by name",
  "agent.starters.tobis.3": "What films has this person worked on?",
  "agent.starters.tobis.4": "What's the best film by a particular actor?",
  "agent.starters.tobis.5": "Which award-winning films do we have in the catalogue?",
  "agent.starters.tobis.6": "Which director has the most drawing power in Germany?",
  "agent.starters.tobis.7": "How has the horror genre trended in cinemas recently?",
  "agent.starters.tobis.8": "Which director is especially in demand right now?",
  "agent.starters.tobis.9": "What would be a fair purchase price for a film like this?",
  "agent.title": "Assistant",
  "agent.tour.back": "Back",
  "agent.tour.buttonHint.back": "Back: revisit the previous step.",
  "agent.tour.buttonHint.next": "Next: continue right away.",
  "agent.tour.buttonHint.pause": "Pause: halt the tour and ask questions.",
  "agent.tour.buttonHint.skipSection": "Skip section: jump to the next area.",
  "agent.tour.buttonHint.stop": "Stop or Esc: end the tour.",
  "agent.tour.chipHome": "Main page",
  "agent.tour.continue": "Continue",
  "agent.tour.escHint": "_Use the buttons below the chat: back, pause, next and skip section. Press **Esc** or the stop button anytime to end the tour._",
  "agent.tour.finished": "That's the end of the tour. Ask me anything about what you saw!",
  "agent.tour.mobileNotice": "Tours highlight elements on the page next to the chat, so they need a larger screen. Please try it on a desktop window.",
  "agent.tour.modeActive": "Tour mode",
  "agent.tour.modeFinished": "Tour finished. Click a snippet or step back to review; stop exits.",
  "agent.tour.modePaused": "Tour paused. You can ask questions now.",
  "agent.tour.next": "Next",
  "agent.tour.next.heading": "Now try it yourself:",
  "agent.tour.next.linkedin": "Import your data via LinkedIn",
  "agent.tour.next.match": "Create a match",
  "agent.tour.next.profile": "Fill out your profile",
  "agent.tour.next.project": "Create a project",
  "agent.tour.next.quiz": "Take a power quiz",
  "agent.tour.noTour": "There is no tour for this page yet.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW is your power playground: assess your 30 powers, watch learning content and play your way to a sharper profile.",
  "agent.tour.pillar.home": "The Smycles logo always takes you to the main page: your dashboard with the latest numbers from every section.",
  "agent.tour.pillar.match": "MATCH builds teams: you define the requirements, the solver picks the right people.",
  "agent.tour.pillar.save": "SAVE is your personal data vault: your profile, CV entries, documents, contacts and pinboard.",
  "agent.tour.pillar.share": "SHARE is the community feed: publish projects and posts, gather interested people and feedback.",
  "agent.tour.questionContinue": "Show everything",
  "agent.tour.questionFinish": "Finish the tour",
  "agent.tour.sectionQuestion": "Should I show you one section first? Pick it below the chat, otherwise I'll present the main page and every section one after another.",
  "agent.tour.sectionQuestionNext": "That section is done. Should I show you another one? Pick it below the chat, otherwise the tour ends here.",
  "agent.tour.sectionsIntro": "I'll quickly show you the sections before we go into details.",
  "agent.tour.skipSection": "Skip section",
  "agent.tour.starterChip": "Show me around this page",
  "agent.tour.starterChipAll": "Show me around the app",
  "agent.tour.stop": "Stop tour",
  "agent.tour.topbar.assistant": "The AI assistant: this button opens and closes the chat you are reading right now.",
  "agent.tour.topbar.chat": "Messages: direct chats with your contacts.",
  "agent.tour.topbar.notifications": "Notifications: invitations, updates and activity around you land here.",
  "agent.tour.topbar.search": "The global search: find people, projects and posts from anywhere in the app.",
  "agent.tour.topbar.user": "Your account: click your name for the profile menu, settings and logout.",
  "agent.tour.welcome": "Welcome to the Smycles system. This tour presents the important features. The buttons under the chat steer the tour. You can also click any chat snippet to jump back to its spot.",
  "agent.untitled": "Untitled chat",
  "auth.redirecting": "Redirecting to login…",
  "auth.sessionExpired.body": "You have been signed out because the session reached its time limit. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.bodyTokensLost": "You have been signed out. Changes are no longer being saved. Sign in again to continue where you left off.",
  "auth.sessionExpired.signIn": "Sign in again",
  "auth.sessionExpired.title": "Session ended",
  "chat.closeChat": "Close chat",
  "chat.deleteChat": "Delete chat",
  "chat.deleteChatConfirm": "Delete this conversation?",
  "chat.liveUpdatesUnavailable": "Live updates unavailable",
  "chat.messageInput": "Message input",
  "chat.messages": "Messages",
  "chat.minimize": "Minimize",
  "chat.more": "More",
  "chat.newConversation": "New conversation",
  "chat.noConversationsYet": "No conversations yet",
  "chat.online": "Online",
  "chat.openMessages": "Messages",
  "chat.searchChats": "Search chats…",
  "chat.searchEnd": "{count} results",
  "chat.searchHint": "Type at least {n} characters",
  "chat.searchPeople": "Search people…",
  "chat.seen": "Seen",
  "chat.sendMessage": "Send message",
  "chat.typing": "typing…",
  "chat.unreadMessages": "{count} unread",
  "chat.writeMessage": "Write a message…",
  "chat.you": "You",
  "cockpit.dismiss": "Dismiss",
  "cockpit.markRead": "Mark read",
  "cockpit.noNotifications": "No notifications",
  "cockpit.notifications": "Notifications",
  "cockpit.unread": "unread",
  "common.add": "Add",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.comingSoon": "Coming soon",
  "common.confirm": "Confirm",
  "common.create": "Create",
  "common.delete": "Delete",
  "common.deleteFailed": "Delete failed.",
  "common.discard": "Discard",
  "common.duplicateName": "An entry with this name already exists. Please choose a different name.",
  "common.edit": "Edit",
  "common.errorWithMessage": "Error: {message}",
  "common.fileDrop.overlay": "Drop to upload …",
  "common.fileDrop.zone": "Drag a file here or click to upload",
  "common.loadMore": "Load more",
  "common.loading": "Loading…",
  "common.loadingMore": "Loading…",
  "common.next": "Next",
  "common.noBackend": "No backend endpoint",
  "common.noResults": "No results found",
  "common.notFound": "Not found",
  "common.notFoundBody": "The page you're looking for doesn't exist.",
  "common.remove": "Remove",
  "common.reset": "Reset",
  "common.save": "Save",
  "common.saveFailed": "Save failed.",
  "common.saving": "Saving…",
  "common.serverError": "Something went wrong. Please try again.",
  "common.serverErrorWithCode": "Something went wrong. Please try again. (Code {code})",
  "common.share.ariaActive": "Sharing active",
  "common.share.ariaAllOff": "All private",
  "common.share.ariaAllOn": "Share all",
  "common.share.ariaInactive": "Not sharing",
  "common.share.off": "Private",
  "common.share.on": "Share",
  "common.tryAgain": "Try again",
  "common.unsavedChanges": "Unsaved changes",
  "community.tour.contacts.desc": "{count} contacts in the current view. Click a card to open the profile, use \"+ Add\" to put it into communities, or drag it onto one on the left.",
  "community.tour.contacts.title": "Your contacts",
  "community.tour.controls.desc": "Search contacts by name, change the sort order, or filter to contacts that are not in any community yet.",
  "community.tour.controls.title": "Search & sort",
  "community.tour.groups.desc": "{count} communities to group your contacts. Click one to see its members, create new ones via \"+ Community\", and drag a contact card onto a community to add it.",
  "community.tour.groups.title": "Your communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "This is your Community page: {contacts} contacts, organized into {groups} communities.",
  "cv.color": "Color",
  "cv.createFailed": "Creating the CV failed.",
  "cv.createTitle": "Create CV",
  "cv.download": "Download",
  "cv.downloadFailed": "Download failed.",
  "cv.editTitle": "Edit CV",
  "cv.field.address": "Location",
  "cv.field.birthDate": "Date of birth",
  "cv.field.drivingLicence": "Driving licence",
  "cv.field.email": "Email",
  "cv.field.nationality": "Nationality",
  "cv.field.phone": "Phone",
  "cv.field.web": "Web",
  "cv.generator": "CV Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Not signed in?",
  "cv.personal.born": "b. {date}",
  "cv.personal.licence": "Licence {value}",
  "cv.previewTitle": "CV Preview",
  "cv.reallyDelete": "Really delete",
  "cv.saveCv": "Save CV",
  "cv.section.certifications": "Certifications",
  "cv.section.education": "Education",
  "cv.section.experience": "Work Experience",
  "cv.section.expertise": "Expertise",
  "cv.section.languages": "Languages",
  "cv.section.summary": "Profile",
  "cv.sectionCertifications": "Certificates",
  "cv.sectionEducation": "Education",
  "cv.sectionExperience": "Work experience",
  "cv.sectionExpertise": "Expertise",
  "cv.sectionLanguages": "Languages",
  "cv.sectionProfile": "Profile",
  "cv.sections": "Sections",
  "cv.sidebarContact": "Contact",
  "cv.sliderHeadingSize": "Heading size",
  "cv.sliderIndentation": "Indentation",
  "cv.sliderSectionMargin": "Section margin",
  "cv.sliderSpacing": "Spacing",
  "cv.sliderTextSize": "Text size",
  "cv.template": "Template",
  "cv.template.comic.tagline": "THE BEST RESUME OF ALL TIME!!!",
  "cv.template.contact": "Contact",
  "cv.updateFailed": "Updating the CV failed.",
  "cv.variant": "Variant {n}",
  "design.addEntry": "Add entry",
  "design.apply": "Apply",
  "design.booleanYes": "Yes",
  "design.cardComments": "Comments",
  "design.cardRating": "Rating",
  "design.cardViews": "Views",
  "design.chipCommented": "Commented",
  "design.chipCreated": "Created",
  "design.chipInterested": "Interested",
  "design.chipRated": "Rated",
  "design.chipWatched": "Watched",
  "design.chooseLevel": "Choose level.",
  "design.clearValue": "Clear value",
  "design.copied": "Copied",
  "design.copy": "Copy",
  "design.cropPhoto": "Crop photo",
  "design.filterPlaceholder": "Type to filter …",
  "design.monthPlaceholder": "Month",
  "design.numberStepperDecrease": "Decrease {noun}",
  "design.numberStepperFallbackNoun": "value",
  "design.numberStepperIncrease": "Increase {noun}",
  "design.removeTask": "Remove task",
  "design.requiredField": "Required field",
  "design.selectPlaceholder": "Select …",
  "design.selfAssessmentDone": "Self-assessment completed",
  "design.shareLink": "Share link",
  "design.shareTitle": "Share",
  "design.shareWithArrow": "↗ Share",
  "design.stillFillIn": "Please still fill in: {fields}",
  "design.yearPlaceholder": "Year",
  "design.zoom": "Zoom",
  "grow.assessment.allAnswered": "All questions answered",
  "grow.assessment.askAria": "Ask the assistant about this statement",
  "grow.assessment.boxAriaLabel": "Go to question {index}",
  "grow.assessment.boxTitle": "Question {index}",
  "grow.assessment.boxTitleAnswered": "Question {index} · answered",
  "grow.assessment.enterToContinue": "Enter to continue",
  "grow.assessment.keyboardHint": "Keys 1–{max} or ←/→ to select",
  "grow.assessment.progress": "Question {index} / {total} · {answered} answered",
  "grow.assessment.saveFailed": "Could not save.",
  "grow.assessment.skip": "Skip",
  "grow.assessment.zoneHint": "↑/↓ switches the row (Questions · Rating · Navigation)",
  "grow.assessmentSubtitle": "Rate how strongly each statement applies to you.",
  "grow.elementAssessment.askIntro.0": "I'm rating the self-assessment statement: \"{statement}\". Help me understand what it means and how to evaluate it for myself.",
  "grow.elementAssessment.askIntro.1": "Help me make sense of this self-assessment statement: \"{statement}\". What does it mean and how should I rate it?",
  "grow.elementAssessment.askIntro.2": "I'm not sure how to rate \"{statement}\". Can you help me interpret and evaluate it?",
  "grow.elementAssessment.askIntro.3": "What is the statement \"{statement}\" really getting at, and how do I judge it for myself?",
  "grow.elementAssessment.askIntro.4": "Walk me through the statement \"{statement}\" so I can rate it honestly.",
  "grow.elementAssessment.askIntro.5": "Help me reflect on \"{statement}\" – what does it mean and how do I assess it?",
  "grow.elementAssessment.askIntro.6": "How should I think about the statement \"{statement}\" when rating myself?",
  "grow.elementAssessment.askIntro.7": "Unpack \"{statement}\" for me and help me decide how much it applies to me.",
  "grow.elementAssessment.askIntro.8": "I'm evaluating \"{statement}\". What does it mean, and what should I consider before rating it?",
  "grow.elementAssessment.askIntro.9": "Explain \"{statement}\" and help me figure out where I fall on it.",
  "grow.elementAssessment.notSaved": "not saved",
  "grow.elementAssessment.savedStatus": "saved",
  "grow.elementAssessment.savingStatus": "saving…",
  "grow.elementAssessment.statementLabel": "Statement {index}",
  "grow.elementAssessment.toEvaluation": "To evaluation",
  "grow.elementResult.answeredCount": "{answered}/{total} answered",
  "grow.elementResult.askButton": "Discuss my result",
  "grow.elementResult.askIntro.0": "I just scored {score} on {name}. Help me understand what that means and how to improve.",
  "grow.elementResult.askIntro.1": "Using the reference material, interpret my {name} result ({score}) and suggest how to grow it.",
  "grow.elementResult.askIntro.2": "What does a {name} score of {score} say about me, and what can I do about it?",
  "grow.elementResult.askIntro.3": "Help me make sense of my {name} result ({score}) and where to go from here.",
  "grow.elementResult.askIntro.4": "I got {score} on {name}. Based on the reference material, how can I develop this power?",
  "grow.elementResult.askIntro.5": "Break down my {name} result ({score}) and give me practical next steps.",
  "grow.elementResult.askIntro.6": "How should I read a {name} score of {score}? What would improvement look like?",
  "grow.elementResult.askIntro.7": "Give me reference-grounded advice for improving {name}, given my score of {score}.",
  "grow.elementResult.askIntro.8": "My {name} came out at {score}. What are concrete ways to strengthen it?",
  "grow.elementResult.askIntro.9": "Interpret my {name} result ({score}) and coach me on improving it.",
  "grow.elementResult.evaluation": "Evaluation",
  "grow.elementResult.fullyAnswered": "Fully answered",
  "grow.elementResult.lastEvaluatedOn": "Last evaluated: {date}",
  "grow.elementResult.reassess": "Assess again",
  "grow.elementResult.selfAssessmentCompleted": "Self-assessment completed",
  "grow.elementResult.toPower": "To Power",
  "grow.elementResult.toPowerMap": "To Power Map",
  "grow.elementResult.unknownElement": "Unknown element",
  "grow.elementResult.yourScore": "Your score",
  "grow.landing.allAssessmentsDone": "All self-assessments completed.",
  "grow.landing.circusStories": "Circus · Expert stories",
  "grow.landing.community": "Community",
  "grow.landing.focusAskButton": "Where should I focus?",
  "grow.landing.focusAskIntro.0": "My weakest powers right now are {powers}. Where should I focus first and why?",
  "grow.landing.focusAskIntro.1": "Help me decide where to start improving – my lowest powers are {powers}.",
  "grow.landing.focusAskIntro.2": "Given my weakest areas ({powers}), what should I work on first?",
  "grow.landing.focusAskIntro.3": "I want to grow. Based on the reference material, how should I prioritize {powers}?",
  "grow.landing.focusAskIntro.4": "Which of these should I tackle first: {powers}? Help me make a plan.",
  "grow.landing.focusAskIntro.5": "Coach me on improving my weak spots: {powers}. Where do I begin?",
  "grow.landing.focusAskIntro.6": "My growth areas are {powers}. What's a good first step for each?",
  "grow.landing.focusAskIntro.7": "Help me turn {powers} from weaknesses into strengths – where to start?",
  "grow.landing.focusAskIntro.8": "What should my focus be, given my lowest powers are {powers}?",
  "grow.landing.focusAskIntro.9": "Suggest a focus and a first action for my weakest powers: {powers}.",
  "grow.landing.gamesExercises": "Games · Playful learning exercises",
  "grow.landing.heroBody": "Quests, games, micro-exercises. Your personal power playground. Move powers without measuring them.",
  "grow.landing.heroSubtitleLine1": "Discover playfully,",
  "grow.landing.heroSubtitleLine2": "what makes you really tick.",
  "grow.landing.improveAria": "Get help improving {name}",
  "grow.landing.inComparison": "In comparison",
  "grow.landing.liveHacks": "Live hacks",
  "grow.landing.loading": "loading…",
  "grow.landing.noCommunityProgress": "No community with grow progress yet.",
  "grow.landing.noData": "No data.",
  "grow.landing.noRatedPowers": "No rated powers yet.",
  "grow.landing.openCount": "{count} open",
  "grow.landing.openProfile": "Open {name}",
  "grow.landing.powerMap": "Power Map ↗",
  "grow.landing.profileFallback": "profile",
  "grow.landing.profileProgress": "Profile progress",
  "grow.landing.progressHint": "Answer all questions about the powers to increase your profile progress.",
  "grow.landing.roomToGrow": "Room to grow",
  "grow.landing.upNext": "Up next",
  "grow.landing.viewAll": "View all ↗",
  "grow.landing.yourStrengths": "Your strengths",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "No questions available for this element.",
  "grow.play.allGames": "All games",
  "grow.play.featured": "Featured",
  "grow.play.filter.all": "All",
  "grow.play.filter.solo": "Solo",
  "grow.play.filter.team": "Team",
  "grow.play.game.back2Future.caption": "You throw your present self into a 10-year future. What do you see there?",
  "grow.play.game.back2Future.duration": "15 min · solo",
  "grow.play.game.back2Future.kind": "Scenario",
  "grow.play.game.creativeJam.caption": "Improvisation setting for 3–6 people. Fast, loud, honest.",
  "grow.play.game.creativeJam.duration": "30 min · team",
  "grow.play.game.creativeJam.kind": "Team improv",
  "grow.play.game.missionBuilder.caption": "Create your personal hero's journey: calling, obstacles, allies.",
  "grow.play.game.missionBuilder.duration": "45 min · solo",
  "grow.play.game.missionBuilder.kind": "Story mode",
  "grow.play.game.perspectiveSwap.caption": "Slip into another role for 10 minutes and see yourself from the outside.",
  "grow.play.game.perspectiveSwap.duration": "10 min · solo / duo",
  "grow.play.game.perspectiveSwap.kind": "Role",
  "grow.play.game.powerQuiz.caption": "90 statements → your power profile. 30 categories, 5-point scale.",
  "grow.play.game.powerQuiz.duration": "20-30 min · solo",
  "grow.play.game.powerQuiz.kind": "Quiz",
  "grow.play.game.teamPuzzle.caption": "Three people, three powers, one problem. Who fits together, and why?",
  "grow.play.game.teamPuzzle.duration": "20 min · team",
  "grow.play.game.teamPuzzle.kind": "Co-op",
  "grow.play.game.treasureHunt.caption": "Treasure map of your strengths: find 5 unrecognized powers in your everyday life.",
  "grow.play.game.treasureHunt.duration": "20 min · solo",
  "grow.play.game.treasureHunt.kind": "Adventure",
  "grow.play.game.valueCards.caption": "60 value cards: prioritize, eliminate, commit. With reflection questions.",
  "grow.play.game.valueCards.duration": "25 min · solo",
  "grow.play.game.valueCards.kind": "Card game",
  "grow.play.headerCount": "{count} games · solo & team",
  "grow.play.intro": "Playful exercises, quizzes and scenarios that get your powers moving. Solo, with a partner or as a team.",
  "grow.play.personPlural": "people",
  "grow.play.personSingular": "person",
  "grow.play.quiz.allAnswered": "All parts answered.",
  "grow.play.quiz.continue": "Continue with part {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.missing": "The Power Quiz is not set up on this environment yet.",
  "grow.play.quiz.partAnswered": "answered",
  "grow.play.quiz.partLabel": "Part {index}",
  "grow.play.quiz.partOpen": "open",
  "grow.play.quiz.partsProgress": "{answered} of {total} parts answered",
  "grow.play.quiz.start": "Start quiz",
  "grow.play.quiz.title": "Power Quiz",
  "grow.play.start": "Start ↗",
  "grow.play.teamCount": "Team · {count}",
  "grow.play.title": "Play",
  "grow.play.tour.filter.desc": "Filter the catalogue: Solo shows games you can play alone, Team the ones for groups.",
  "grow.play.tour.filter.title": "Solo or team",
  "grow.play.tour.grid.desc": "The rest of the catalogue holds {count} more games like scenarios, card games and team exercises. Cards with a play button are ready to start.",
  "grow.play.tour.grid.title": "All games",
  "grow.play.tour.label": "Grow Play",
  "grow.play.tour.quiz.desc": "The featured game: 90 statements across all 30 powers on a 5-point scale. Your answers build your power profile. Click here to start.",
  "grow.play.tour.quiz.title": "The Power Quiz",
  "grow.play.tour.summary": "This is the Play arcade: {count} playful games and exercises that get your powers moving, solo or as a team.",
  "grow.powerDetail.answeredCount": "{answered}/{total} answered",
  "grow.powerDetail.askButton": "Ask the assistant",
  "grow.powerDetail.askImprove.0": "How can I improve my {name}? Give me reference-grounded, practical steps.",
  "grow.powerDetail.askImprove.1": "Based on the reference material, what are concrete ways to develop {name}?",
  "grow.powerDetail.askImprove.2": "Coach me on strengthening {name} – where do I start?",
  "grow.powerDetail.askImprove.3": "Give me exercises or habits from the reference material to grow {name}.",
  "grow.powerDetail.askImprove.4": "What does the reference material suggest for improving {name}?",
  "grow.powerDetail.askImprove.5": "Help me build a simple plan to improve {name}.",
  "grow.powerDetail.askImprove.6": "What are the best first steps to strengthen {name}?",
  "grow.powerDetail.askImprove.7": "How do people typically develop {name}? Draw on the reference material.",
  "grow.powerDetail.askImprove.8": "Give me a few practical ways to work on {name}.",
  "grow.powerDetail.askImprove.9": "I want to get better at {name}. What should I do, according to the reference material?",
  "grow.powerDetail.askImproveButton": "How do I improve this?",
  "grow.powerDetail.askIntro.0": "Using the reference material, give me an intro to {name} and tell me more about it.",
  "grow.powerDetail.askIntro.1": "Introduce me to {name} based on the reference material – what is it about?",
  "grow.powerDetail.askIntro.2": "Draw on the reference material to explain {name} to me.",
  "grow.powerDetail.askIntro.3": "What does the reference material say about {name}? Give me an overview.",
  "grow.powerDetail.askIntro.4": "Give me a beginner-friendly intro to {name}, grounded in the reference material.",
  "grow.powerDetail.askIntro.5": "Walk me through {name} using the reference material.",
  "grow.powerDetail.askIntro.6": "From the reference material, summarize what {name} is and why it matters.",
  "grow.powerDetail.askIntro.7": "Help me understand {name} – use the reference material for an intro.",
  "grow.powerDetail.askIntro.8": "Explain {name} to me from the reference material, as if I'm new to it.",
  "grow.powerDetail.askIntro.9": "Based on the reference material, what should I know about {name}?",
  "grow.powerDetail.confidence": "Confidence: {percent}%",
  "grow.powerDetail.continueSelfAssessment": "Continue self-assessment",
  "grow.powerDetail.evidence": "Evidence ({count})",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noEvidence": "No evidence available. Upload documents into the {link} to gather evidence.",
  "grow.powerDetail.noPodcasts": "No podcasts for “{name}” yet.",
  "grow.powerDetail.noScripts": "No scripts for “{name}” yet.",
  "grow.powerDetail.noSmartAnalysis": "No smart analysis for this power yet.",
  "grow.powerDetail.noVideos": "No videos for “{name}” yet.",
  "grow.powerDetail.openDocument": "Open document",
  "grow.powerDetail.openDocumentNamed": "Open document {name}",
  "grow.powerDetail.page": "Page {number}",
  "grow.powerDetail.podcasts": "Podcasts",
  "grow.powerDetail.powerAnalysis": "power analysis",
  "grow.powerDetail.powerDetails": "Power details",
  "grow.powerDetail.questionnaires": "Questionnaires",
  "grow.powerDetail.rationale": "Rationale",
  "grow.powerDetail.repeatSelfAssessment": "Repeat self-assessment",
  "grow.powerDetail.revealPower": "Reveal “{name}”",
  "grow.powerDetail.scripts": "Scripts",
  "grow.powerDetail.selfAssessment": "Self-assessment",
  "grow.powerDetail.selfEvaluation": "Self-evaluation",
  "grow.powerDetail.selfEvaluationIntro": "Answer the statements about “{name}”. Your result feeds into the self-assessment score; once you have answered all of them you earn the medal.",
  "grow.powerDetail.smartAnalysis": "Smart Analysis",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Start self-assessment",
  "grow.powerDetail.tour.artwork.desc": "The artwork is only as sharp as your self-assessment is complete. So far you have answered {answered} of {total} statements. Answer more to reveal it fully.",
  "grow.powerDetail.tour.artwork.title": "The artwork reveal",
  "grow.powerDetail.tour.description.desc": "Read what \"{name}\" stands for and which cluster it belongs to. That is good grounding before you rate yourself.",
  "grow.powerDetail.tour.description.title": "What this power means",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.selfEvaluation.desc": "Answer the statements about \"{name}\" here; {answered} of {total} are done. Completing all of them earns the medal and sharpens the artwork.",
  "grow.powerDetail.tour.selfEvaluation.doneDesc": "All {total} statements answered. Your self-assessment score is {score}. You can repeat the assessment anytime to update it.",
  "grow.powerDetail.tour.selfEvaluation.title": "Self-evaluation",
  "grow.powerDetail.tour.summary": "This page is all about the power \"{name}\" ({abbr}). {status}",
  "grow.powerDetail.tour.summaryStatus": "You have answered {answered} of {total} self-assessment statements.",
  "grow.powerDetail.tour.summaryStatusNone": "You haven't self-assessed it yet.",
  "grow.powerDetail.videos": "Videos",
  "grow.powerLibrary.all": "All",
  "grow.powerLibrary.askButton": "Read my Power Map",
  "grow.powerLibrary.askIntro.0": "Read my Power Map – where are my strengths and gaps, and what should I focus on?",
  "grow.powerLibrary.askIntro.1": "Give me an overview of my powers: what's strong, what's weak, and where to grow.",
  "grow.powerLibrary.askIntro.2": "Interpret my power profile – the highs, the lows, and a suggested focus.",
  "grow.powerLibrary.askIntro.3": "Based on my powers and the reference material, what patterns do you see?",
  "grow.powerLibrary.askIntro.4": "Help me understand my overall power profile and where to invest.",
  "grow.powerLibrary.askIntro.5": "What do my strongest and weakest powers say about me?",
  "grow.powerLibrary.askIntro.6": "Summarize my power landscape and recommend a growth focus.",
  "grow.powerLibrary.askIntro.7": "Where are my biggest opportunities across my powers?",
  "grow.powerLibrary.askIntro.8": "Walk me through my Power Map and suggest what to work on first.",
  "grow.powerLibrary.askIntro.9": "Give me a big-picture read of my powers and a place to start.",
  "grow.powerLibrary.clearSearch": "Clear search",
  "grow.powerLibrary.eyebrow": "Power Map",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.noResults": "No power found for “{query}”.",
  "grow.powerLibrary.onlyUnrated": "Unrated",
  "grow.powerLibrary.openPower": "Open {name}",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.profileProgress": "Profile progress",
  "grow.powerLibrary.profileProgressTooltip": "Answer all questions about the powers to increase your profile progress.",
  "grow.powerLibrary.searchPlaceholder": "Search by name or abbreviation",
  "grow.powerLibrary.sourceCombined": "Combined",
  "grow.powerLibrary.sourceSelf": "Self-assessment",
  "grow.powerLibrary.sourceSmart": "Smart Analysis",
  "grow.powerLibrary.subheading": "The complete vocabulary: {clusters} clusters, {powers} powers.",
  "grow.powerLibrary.tour.filters.desc": "Search powers by name or abbreviation, or tap Unrated to see only the {unrated} powers whose self-assessment you haven't completed yet.",
  "grow.powerLibrary.tour.filters.title": "Search & filter",
  "grow.powerLibrary.tour.grid.desc": "All {total} powers grouped into {clusters} clusters. Click a tile to open that power. A medal and its artwork appear once its self-assessment is complete; {completed} earned so far.",
  "grow.powerLibrary.tour.grid.title": "The power tiles",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Switch which evaluation the numbers on all tiles show. Pick Self-assessment to see the scores from your own ratings.",
  "grow.powerLibrary.tour.scoreSource.title": "Score source",
  "grow.powerLibrary.tour.summary": "This is the Power Map: all {total} powers, periodic-table style. You have fully self-assessed {completed} of {total} so far.",
  "grow.powerQuestionnaires.answer": "Answer",
  "grow.powerQuestionnaires.completed": "completed",
  "grow.powerQuestionnaires.empty": "No questionnaires linked to \"{powerName}\" yet.",
  "grow.powerQuestionnaires.heading": "Questionnaires",
  "grow.powerQuestionnaires.loading": "loading…",
  "grow.powerQuestionnaires.repeat": "Repeat",
  "grow.questionnaire.eyebrow": "Grow · Questionnaire",
  "grow.questionnaire.fallbackName": "Questionnaire",
  "grow.questionnaire.noQuestions": "No questions in this questionnaire.",
  "grow.questionnaire.questionLabel": "Question {position}",
  "grow.questionnaire.submit": "Submit",
  "grow.questionnaire.unknownElement": "Unknown element",
  "grow.title": "Grow",
  "grow.tour.label": "Grow",
  "grow.tour.progress.desc": "Your overall progress: {score}%{rank, select, none {} other { (rank: {rank})}}. Answering power questions raises it. Click 'Power Map' to see all 30 powers.",
  "grow.tour.progress.title": "Profile progress",
  "grow.tour.room.desc": "{count, plural, =0 {Your weakest rated powers will appear here.} other {Your lowest-rated powers: {names}. The button below asks me for improvement ideas.}}",
  "grow.tour.room.title": "Room to grow",
  "grow.tour.strengths.desc": "{count, plural, =0 {Once you rate powers, your top ones appear here.} other {Your strongest powers right now: {names}.}}",
  "grow.tour.strengths.title": "Your strengths",
  "grow.tour.summary": "This is your Grow dashboard. Your overall power score is {score}%.",
  "grow.tour.upNext.desc": "{count, plural, =0 {All self-assessments are done. Nothing is open.} other {You have {count} open self-assessments; the ones closest to completion are listed first. Click one to continue rating.}}",
  "grow.tour.upNext.title": "Up next",
  "grow.unknownElement": "Unknown element",
  "grow.watch.contentCount": "{count} content items",
  "grow.watch.emptyContent": "No content available yet. As soon as videos, podcasts or scripts exist, they will appear here.",
  "grow.watch.filterAll": "All",
  "grow.watch.intro": "Content to consume around your powers: videos, podcasts and scripts. Sit down, watch, listen and read up.",
  "grow.watch.loadingContent": "Content is loading …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} content items, each tagged with its power and cluster. Click a card to consume it.",
  "grow.watch.tour.content.emptyDesc": "No content is available yet. As soon as videos, podcasts or scripts exist, they will appear here as cards you can open.",
  "grow.watch.tour.content.title": "The catalogue",
  "grow.watch.tour.emptySummary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there is nothing here yet.",
  "grow.watch.tour.filters.desc": "Narrow the catalogue by format (videos, podcasts or scripts), or pick All for everything.",
  "grow.watch.tour.filters.title": "Content filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "This is Watch: learning content around your powers as videos, podcasts and scripts. Right now there are {count} items here.",
  "home.allMatches": "All matches ↗",
  "home.allRated": "all rated",
  "home.candidatesCount": "{count, plural, one {# candidate} other {# candidates}}",
  "home.certificate": "Certificate",
  "home.communitiesSub": "{count, plural, one {# community} other {# communities}}",
  "home.community": "Community",
  "home.contacts": "Contacts",
  "home.documents": "Documents",
  "home.draft": "Draft",
  "home.education": "Education",
  "home.entries": "entries",
  "home.greeting": "Glad you're here.",
  "home.group": "Group",
  "home.inComparison": "In comparison · Community",
  "home.myPosts": "My posts ↗",
  "home.noCommunity": "No community yet.",
  "home.noContacts": "no contacts yet",
  "home.noMatches": "No matches",
  "home.noOwnPosts": "No posts of your own yet",
  "home.noOwnPostsHint": "create a project or a post",
  "home.noPins": "nothing pinned yet",
  "home.notRatedYet": "not rated yet",
  "home.notStarted": "not started yet",
  "home.openCount": "{count} open",
  "home.openProfileOf": "Open {name}",
  "home.personsCount": "{count, plural, one {# person} other {# people}}",
  "home.pins": "Pins",
  "home.postsCount": "{count, plural, one {# post} other {# posts}}",
  "home.powerVersus": "Power Versus",
  "home.profile": "Profile",
  "home.profileEmpty": "nothing recorded yet",
  "home.profileFallback": "Profile",
  "home.profileProgress": "Profile progress",
  "home.projectsCount": "{count, plural, one {# project} other {# projects}}",
  "home.rated": "Rated",
  "home.searchCommunities": "Search communities",
  "home.searchGroups": "Search groups",
  "home.service": "Documents",
  "home.serviceEmpty": "nothing filed yet",
  "home.strongest": "Strongest: {name}",
  "home.tobis.favorites": "Favourites",
  "home.tobis.favoritesEmpty": "No favourites yet. Use the star on a title or person page.",
  "home.tobis.market": "Market",
  "home.tobis.marketSub": "latest TV day · {days, plural, one {# day} other {# days}} on record",
  "home.tobis.people": "People",
  "home.tobis.recent": "Just arrived",
  "home.tobis.title": "Movie",
  "home.tobis.titles": "Titles",
  "home.tobis.updatedToday": "updated today · {week} in 7 days",
  "home.tobis.viewAll": "All titles ↗",
  "home.tour.grow.desc": "Your profile progress, strongest powers and open self-assessments.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Home",
  "home.tour.match.desc": "Your matches. Click one to continue where you left off.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Your profile entries, documents, contacts and pins, with quick actions to add new ones.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Your posts and projects and what is happening around them.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "This is the main page: the latest numbers from every section at a glance. Every tile links to its spot in the app.",
  "home.tour.tobis.desc": "What the last import brought in: titles, people and the market, each tile linking to its list.",
  "home.tour.tobis.title": "Movie",
  "home.unnamedMatch": "Unnamed match",
  "home.uploadFile": "Upload file",
  "home.viewAll": "View all ↗",
  "home.viewPower": "Show {name}",
  "home.viewPowerMap": "Show Power Map",
  "home.viewUnrated": "Show unrated",
  "home.weakestSuffix": " vs. Weakest: {name}",
  "home.workExperience": "Work experience",
  "likert.1": "Does not apply",
  "likert.2": "Rather does not apply",
  "likert.3": "Partly",
  "likert.4": "Rather applies",
  "likert.5": "Fully applies",
  "linkedin.error.authorize_denied": "LinkedIn authorization was cancelled.",
  "linkedin.error.cancelled": "You cancelled the LinkedIn connection. You can connect again whenever you're ready.",
  "linkedin.error.import_failed": "The import failed. Please try again later.",
  "linkedin.error.invalid_callback": "The LinkedIn response was incomplete. Please try again.",
  "linkedin.error.invalid_state": "The LinkedIn session expired. Please try again.",
  "linkedin.error.not_configured": "LinkedIn import is not configured. Contact your administrator.",
  "linkedin.error.reconnect": "Your LinkedIn session expired or access wasn't complete. Please reconnect.",
  "linkedin.error.stillImporting": "Your import is taking longer than expected. It's still running – refresh this page in a moment to see the result.",
  "linkedin.error.temporary": "LinkedIn didn't respond in time. Please try again in a moment.",
  "linkedin.error.token_exchange": "Could not connect to LinkedIn. Please try again later.",
  "linkedin.error.unavailable": "LinkedIn import isn't available right now. Please contact your administrator.",
  "linkedin.error.unexpected": "Something went wrong during the import. Please try again later.",
  "linkedin.import.abort": "Abort import",
  "linkedin.import.abortTip": "Still importing – you can keep waiting, or abort and start the import over from the beginning. Nothing has been saved yet.",
  "linkedin.import.alreadyUpToDate": "Everything LinkedIn could add is already in your profile.",
  "linkedin.import.close": "Close",
  "linkedin.import.connect": "Connect LinkedIn",
  "linkedin.import.dialogTitle": "LinkedIn import",
  "linkedin.import.elapsed": "Elapsed time: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Current employer",
  "linkedin.import.field.dateOfBirth": "Date of birth",
  "linkedin.import.field.degree": "Degree",
  "linkedin.import.field.description": "Description",
  "linkedin.import.field.email": "Email",
  "linkedin.import.field.employer": "Employer",
  "linkedin.import.field.endDate": "End date",
  "linkedin.import.field.fieldOfStudy": "Field of study",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Issued",
  "linkedin.import.field.jobTitle": "Job title",
  "linkedin.import.field.language": "Language",
  "linkedin.import.field.level": "Level",
  "linkedin.import.field.location": "Location",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Period",
  "linkedin.import.field.phone": "Phone",
  "linkedin.import.field.profession": "Profession",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Start date",
  "linkedin.import.field.street": "Street",
  "linkedin.import.field.title": "Title",
  "linkedin.import.field.zipCode": "Zip code",
  "linkedin.import.importing": "Importing your LinkedIn data – this can take up to a minute…",
  "linkedin.import.intro": "Connect your LinkedIn account to import your profile, positions and skills. You'll review what to keep or replace before anything is saved.",
  "linkedin.import.loadingResult": "Finishing import…",
  "match.result.ranking.actualInline": "Evidence:",
  "match.result.ranking.assessment.interviewQuestions": "Questions for the conversation",
  "match.result.ranking.assessment.ratingVeryHigh": "Highly suitable",
  "match.result.ranking.assessment.ratingHigh": "Suitable",
  "match.result.ranking.assessment.ratingMedium": "Partly suitable",
  "match.result.ranking.assessment.ratingLow": "Rather unsuitable",
  "match.result.ranking.assessment.ratingVeryLow": "Unsuitable",
  "match.result.ranking.fulfilledTab": "Fulfilled ({count})",
  "match.result.ranking.unfulfilledTab": "Not fulfilled ({count})",
  "match.result.suitability.basis": "AI overall assessment",
  "match.result.suitability.empty": "No AI suitability scores yet. Please run the match again.",
  "match.result.suitability.header": "Top 5 – best fit",
  "match.result.suitability.openProfile": "{name} – open profile",
  "match.result.suitability.rankLabel": "Rank {rank}",
  "match.result.suitability.scoreLabel": "AI suitability {score}%",
  "profile.merge.save": "Save changes",
  "profile.merge.saving": "Saving…",
  "profile.merge.savePartial": "{count, plural, one {# change couldn't be saved. Please try again.} other {# changes couldn't be saved. Please try again.}}",
  "profile.merge.dateBlocked": "Some dates need fixing before saving.",
  "profile.merge.fieldBlocked": "Some values need fixing before saving.",
  "profile.merge.languageBlocked": "Choose a real language for the imported entry, or skip it.",
  "profile.merge.language.unknown": "“{value}” is not a recognizable language. Choose the right one, or skip this entry.",
  "profile.merge.reviewBlocked": "Review every change before saving.",
  "profile.merge.date.future": "This date can't be in the future.",
  "profile.merge.date.format": "Use a date like YYYY, YYYY-MM or YYYY-MM-DD.",
  "profile.merge.date.range": "End date must be on or after the start date.",
  "profile.merge.date.beforeBirth": "This date is before the date of birth.",
  "profile.merge.field.tooLong": "Keep this to {max} characters or fewer.",
  "profile.merge.field.invalidEmail": "Enter a valid email address.",
  "profile.merge.field.invalidPhone": "Enter a valid phone number.",
  "profile.merge.field.childCountMax": "The number of children cannot exceed {max}.",
  "profile.merge.bar.aria": "Import changes",
  "profile.merge.bar.open": "{count, plural, one {# field left to review} other {# fields left to review}}",
  "profile.merge.bar.allReviewed": "All changes reviewed",
  "profile.merge.bar.previous": "Previous",
  "profile.merge.bar.next": "Next",
  "profile.merge.guide.step": "{current, number} of {total, number}",
  "profile.merge.guide.review": "Review",
  "profile.merge.status.keep": "Keeping your value",
  "profile.merge.status.use": "Using the imported value",
  "profile.merge.status.add": "Will be added",
  "profile.merge.status.skip": "Skipped",
  "profile.merge.keepAll": "Keep all mine",
  "profile.merge.useAll": "Use all imported",
  "profile.merge.skip": "Skip",
  "profile.merge.add": "Add",
  "profile.merge.showMore": "Show more",
  "profile.merge.showLess": "Show less",
  "profile.merge.badge.new": "New",
  "profile.merge.badge.conflict": "Differs",
  "profile.merge.incomingLabel": "Imported",
  "profile.merge.keep": "Keep mine",
  "profile.merge.use": "Use imported",
  "profile.merge.chooseAria": "Keep your value or use the imported one",
  "profile.merge.side.existing": "Your value",
  "profile.merge.editAria.existing": "Edit your value",
  "profile.merge.editAria.incoming": "Edit the imported value",
  "profile.merge.reset.existing": "Reset to your saved value",
  "profile.merge.reset.incoming": "Reset to the imported value",
  "profile.merge.replacesSaved": "Replaces your saved value",
  "profile.merge.replacesSavedRow": "Replaces your saved entry",
  "profile.merge.skills.importAllAria": "Import all skills",
  "profile.merge.cefr.native": "Native",
  "linkedin.import.openingReview": "Opening your profile to review the changes…",
  "linkedin.import.warning.certificateInvalidName": "A certificate was skipped because its name was invalid.",
  "linkedin.import.warning.certificateNameDefaulted": "A certificate had no name and was imported with a placeholder.",
  "linkedin.import.warning.educationInvalidStartDate": "An education entry was skipped because its start date was invalid.",
  "linkedin.import.warning.educationMissingFieldOfStudyAndDegree": "An education entry was skipped because it had no field of study or degree.",
  "linkedin.import.warning.educationStartDateDefaulted": "An education entry had no start date and was set to the current month.",
  "linkedin.import.warning.experienceInvalidJobTitle": "A position was skipped because its job title was invalid.",
  "linkedin.import.warning.experienceInvalidStartDate": "A position was skipped because its start date was invalid.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "A position had no job title and was imported with a placeholder.",
  "linkedin.import.warning.experienceStartDateDefaulted": "A position had no start date and was set to the current month.",
  "linkedin.import.warning.languageMissingName": "A language was skipped because it had no name.",
  "linkedin.import.warning.languageTagTooLong": "A language was skipped because its name was too long.",
  "linkedin.import.warning.languageUnrecognizedName": "A language was skipped because its name wasn't recognized.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "A language's proficiency level wasn't recognized.",
  "match.addDocumentsAriaLabel": "Add documents",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "This match is supported by Agentic AI: requirements, research and suggestions are added automatically.",
  "match.agenticAiConfig": "Agentic AI configuration",
  "match.agenticAiOff": "Agentic AI off",
  "match.agenticAiOn": "Agentic AI on",
  "match.agenticAiQuestion": "Should this match be supported by Agentic AI?",
  "match.aiHintsPlaceholder": "Optional hints for the AI: focus, tone, must-haves, what to avoid …",
  "match.challenge.aiAssist": "AI assistance",
  "match.challenge.aiAssistHint": "AI checks requirements that lack direct profile evidence and writes an assessment with a score for every person.",
  "match.challenge.aiDeriveHint": "Derives team size, requirements and powers automatically from title and description. You can adjust everything afterwards.",
  "match.challenge.aiDeriveHintNoTeamSize": "Derives requirements and powers automatically from title and description. You can adjust everything afterwards.",
  "match.challenge.aiFillFirstHint": "Fill in the requirements prompt or the detailed description first so the AI has something to work from.",
  "match.challenge.aiGenerating": "AI generating…",
  "match.challenge.aiWorking": "AI is working – please wait.",
  "match.challenge.describeProject": "Describe project",
  "match.challenge.describeRole": "Describe role",
  "match.challenge.enterTitle": "Enter title",
  "match.challenge.generateWithAi": "Generate with AI",
  "match.challenge.linkBtn": "Link",
  "match.challenge.linkProjectTitle": "Link project to an existing Share item",
  "match.challenge.noFilesYet": "No files yet.",
  "match.challenge.openLinkedShare": "Open linked Share item",
  "match.challenge.projectTitleLabel": "Project title",
  "match.challenge.roleTitleLabel": "Role title",
  "match.challenge.publishBtn": "Publish",
  "match.challenge.requirements": "Requirements",
  "match.challenge.requirementsSharedInfo": "Only profile information that candidates have shared is taken into account.",
  "match.challenge.requirementsSharedInfoLabel": "Note",
  "match.challenge.unlink": "Unlink",
  "match.challenge.unlinkTitle": "Unlink from Share item",
  "match.challenge.unnamedSharedItem": "Unnamed Share item",
  "match.charsCount": "{count} characters",
  "match.detail.error": "Error: {message}",
  "match.detail.invalidUrl": "Invalid match URL.",
  "match.detail.loading": "Loading…",
  "match.detail.notFound": "Match not found.",
  "match.detailedPlaceholder": "Context, outcome, constraints, prior experience, anything else relevant.",
  "match.docs.retry": "↻ Retry",
  "match.docs.tooLarge": "Too large (max. {max} MB per file): {names}",
  "match.docs.uploadFailed": "Upload failed.",
  "match.docs.uploading": "Uploading…",
  "match.documents": "Documents",
  "match.dropFiles": "Drag files <b>here</b> or click",
  "match.editor.reset": "Reset",
  "match.fieldDetailedDesc": "Detailed description",
  "match.fieldShortDesc": "Short description",
  "match.freitext.addJobTitle": "Job title",
  "match.freitext.addSkill": "Skill",
  "match.freitext.jobTitlePlaceholder": "e.g. Senior Designer, Lead Engineer",
  "match.freitext.levelLabel": "Level",
  "match.freitext.skillPlaceholder": "e.g. C++, Production Workflows",
  "match.freitext.title": "Expertise & Work Experience",
  "match.group.COMMUNICATION": "Communication",
  "match.group.FUTURE_ORIENTATION": "Future Orientation",
  "match.group.INVENTIVENESS": "Inventiveness",
  "match.group.RESILIENCE": "Resilience",
  "match.group.RESULT_ORIENTATION": "Result Orientation",
  "match.group.TEAM_SPIRIT": "Teamability",
  "match.kpiTeamSize": "Team size",
  "match.labelLanguage": "Language",
  "match.landing.body": "Initiate a match, define requirements and let the solver compose people and agentic AI into an optimal team – transparent, weighted, explainable.",
  "match.landing.candidatesCount": "{count} candidates",
  "match.landing.error": "Error: {message}",
  "match.landing.loading": "loading…",
  "match.landing.newMatch": "Create new match ↗",
  "match.landing.noMatches": "No matches",
  "match.landing.noMatchesHint": "… or not signed in",
  "match.landing.resultsCount": "{count} results",
  "match.landing.subtitle": "From the idea of a team{br}to the best team.",
  "match.landing.yourMatches": "Your Matches",
  "match.matchNameLabel": "Match name",
  "match.new.accessLabel": "Access",
  "match.new.create": "Create",
  "match.new.creating": "Creating …",
  "match.new.defaultName": "New match",
  "match.new.title": "Create a new match",
  "match.modal.accessCount": "Access · {count}",
  "match.modal.addPersonPlaceholder": "+ Add person – search by name …",
  "match.modal.chooseShareItem": "Choose Share item",
  "match.modal.fillTitle": "Fill the project from the Share item",
  "match.modal.link": "Link",
  "match.modal.linkOnly": "Link only",
  "match.modal.linkOnlyTitle": "Link without copying contents",
  "match.modal.linkWithShareItem": "Link to Share item",
  "match.modal.linking": "Linking …",
  "match.modal.loadingEllipsis": "loading …",
  "match.modal.matchNotes": "Match notes",
  "match.modal.matchNotesPlaceholder": "Internal notes, context or open questions – not the project description.",
  "match.modal.myShareItems": "My Share items",
  "match.modal.myShareItemsCount": "My Share items · {count}",
  "match.modal.nameNotesAccess": "Name, notes & access",
  "match.modal.noAccessYet": "Nobody has access yet. Add a person below.",
  "match.modal.noHits": "No hits.",
  "match.modal.noWriteRights": "You don't have write access to these match settings.",
  "match.modal.overwriteTitle": "Overwrite project contents with the Share item",
  "match.modal.owner": "Owner",
  "match.modal.ownerCreatedBy": "Owner · created by",
  "match.modal.publishEyebrow": "Publish",
  "match.modal.publishHint": "Image, theme and audience need to be added afterwards in the Share editor.",
  "match.modal.publishNow": "Publish now",
  "match.modal.publishOpenInEditor": "Open in editor",
  "match.modal.publishOpeningEditor": "Opening …",
  "match.modal.publishPublishing": "Publishing …",
  "match.modal.publishQuestion": "How do you want to publish the project as a Share item?",
  "match.modal.removeLink": "Remove link?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Editor",
  "match.modal.roleHintAdmin": "Manage all content + access",
  "match.modal.roleHintEditor": "Edit content",
  "match.modal.roleHintReader": "View only",
  "match.modal.roleReader": "Reader",
  "match.modal.savingEllipsis": "Saving …",
  "match.modal.searchByName": "Search by name …",
  "match.modal.searchingEllipsis": "searching …",
  "match.modal.takeOver": "Take over",
  "match.modal.unlinkAction": "Unlink",
  "match.modal.unlinkBody": "The link to <b>{name}</b> will be removed.",
  "match.modal.unlinkEyebrow": "Unlink",
  "match.modal.unlinkHint": "The copied content (title, description, documents) stays – only the reference to the Share item disappears.",
  "match.modal.unlinking": "Unlinking …",
  "match.modal.unnamedShareItem": "Unnamed Share item",
  "match.modal.visibleToMe": "Visible to me",
  "match.modal.visibleToMeCount": "Visible to me · {count}",
  "match.modePicker.assessOutput": "verdict + gaps",
  "match.modePicker.assessSlogan": "You already have a team in mind and want to see how well it fits and where the gaps are.",
  "match.modePicker.assessTitle": "Assess team",
  "match.modePicker.optimizeTitle": "Optimize team",
  "match.modePicker.rankTitle": "Rank candidates",
  "match.modePicker.optimizeOutput": "one team",
  "match.modePicker.optimizeSlogan": "You have a pool of people and need to form the best team for a project or task.",
  "match.modePicker.outputLabel": "Result",
  "match.modePicker.rankOutput": "ranked list",
  "match.modePicker.rankSlogan": "You're filling an open position and want candidates sorted by who fits best.",
  "match.modePicker.title": "What question should this match answer?",
  "match.noMatchesEmpty": "No matches",
  "match.noPeopleFound": "No people found",
  "match.notConnectedYet": "not connected yet",
  "match.optChoose": "– choose –",
  "match.people.addAll": "Add all ({count})",
  "match.people.addAllFromSet": "Add all {count} from {name}",
  "match.people.addAllPinned": "Add all {count} pinned",
  "match.people.addInterested": "Add interested people ({count})",
  "match.people.addUpTo": "Add up to {count} matching",
  "match.people.added": "Added",
  "match.people.allPinned": "All pinned",
  "match.people.evaluateLocked": "Evaluate this team",
  "match.people.evaluateLockedTitle": "Evaluate this fully-locked team",
  "match.people.emptyCandidates": "No candidates yet – add them on the left via search or filters.",
  "match.people.finderTitle": "Person Finder",
  "match.people.interestedExplain": "People who showed interest in this project",
  "match.people.intro": "Search and filter people from your company and add them as candidates.",
  "match.people.introLock": "Mark individual people as locked candidates when they must be part of the team.",
  "match.people.lockAsFix": "Mark as fix in team",
  "match.people.personGroups": "Groups",
  "match.people.pinGroups": "Pin groups",
  "match.people.sampleNotice": "Candidate pool contains the first {count} of {total} matching people from the last bulk add.",
  "match.people.sampleNoticeCapped": "Candidate pool contains the first {count} matching people; more matched than could be added at once.",
  "match.people.savedSetsPlaceholder": "Groups & pins …",
  "match.people.searchPlaceholder": "Name, job title …",
  "match.people.selectedCandidates": "Selected Candidates",
  "match.people.unlock": "Unlock",
  "match.placeholderCount": "Count",
  "match.preSolve.assessTeam": "Assess team",
  "match.preSolve.assessing": "Assessing team…",
  "match.preSolve.rankCandidates": "Rank candidates",
  "match.preSolve.ranking": "Ranking…",
  "match.preSolve.candidatesLoaded": "Candidates loaded",
  "match.preSolve.conditionsComplete": "Criteria complete",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# criterion without a selection (e.g. choose an industry) – complete or remove it} other {# criteria without a selection – complete or remove them}}",
  "match.preSolve.eyebrow": "Ready to solve",
  "match.preSolve.eyebrowAssess": "Ready to assess",
  "match.preSolve.eyebrowRank": "Ready to rank",
  "match.preSolve.headingAssess": "Assess how well your team meets the requirements.",
  "match.preSolve.headingRank": "Rank your candidates by fit to the requirement profile.",
  "match.challenge.assessmentDetail": "Level of detail",
  "match.challenge.assessmentDetailBullets": "Bullet points",
  "match.challenge.assessmentDetailBulletsDescription": "Compact points separated by line breaks.",
  "match.challenge.assessmentDetailInfo": "Explain level of detail",
  "match.challenge.assessmentDetailLongText": "Long text",
  "match.challenge.assessmentDetailLongTextDescription": "Detailed reasoning with concrete evidence.",
  "match.challenge.assessmentDetailSentences": "Sentences",
  "match.challenge.assessmentDetailSentencesDescription": "Short, complete sentences.",
  "match.challenge.assessmentOutcomeBalanced": "Balanced",
  "match.challenge.assessmentOutcomeBalancedDescription": "Neutral assessment, strengths and gaps weighted equally.",
  "match.challenge.assessmentOutcomeFocus": "Outcome focus",
  "match.challenge.assessmentOutcomeFocusInfo": "Explain outcome focus",
  "match.challenge.assessmentOutcomeOpportunities": "Opportunities",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Benevolent assessment: strengths and deployment opportunities first.",
  "match.challenge.assessmentOutcomeRisks": "Risks",
  "match.challenge.assessmentOutcomeRisksDescription": "Reviews the CV specifically for gaps and names them first.",
  "match.challenge.assessmentStrictness": "Evaluation strictness",
  "match.challenge.assessmentStrictnessExtreme": "Extreme",
  "match.challenge.assessmentStrictnessExtremeDescription": "Only explicit, role-relevant evidence counts; every gap costs significant points.",
  "match.challenge.assessmentStrictnessInfo": "Explain evaluation strictness",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "Uses the normal scoring calibration.",
  "match.challenge.assessmentStrictnessStrict": "Strict",
  "match.challenge.assessmentStrictnessStrictDescription": "Unclear or merely implied experience moderately lowers the score.",
  "match.challenge.hrPromptLabel": "Assessment style",
  "match.challenge.requirementLeniency": "Requirement check",
  "match.challenge.requirementLeniencyInfo": "Explain requirement check",
  "match.challenge.requirementLeniencyLenient": "Lenient",
  "match.challenge.requirementLeniencyLenientDescription": "The required level is a guideline: present expertise suffices.",
  "match.challenge.requirementLeniencyMustStrict": "Lenient for optional",
  "match.challenge.requirementLeniencyMustStrictDescription": "Must criteria have to reach the level, presence suffices for optional ones.",
  "match.challenge.requirementLeniencyStrict": "Strict for both",
  "match.challenge.requirementLeniencyStrictDescription": "Must and optional criteria have to reach the required level.",
  "match.preSolve.fulfillFirst": "Satisfy the requirements above first.",
  "match.preSolve.fullyLockedHint": "All {teamSize} seats are filled by locked members. The Solver will only evaluate this team, not optimize it.",
  "match.preSolve.lockedExceedsHeading": "More people are locked than there are seats.",
  "match.preSolve.lockedExceedsBody": "{locked} people are locked in, but the team has {teamSize} seats. Unlock some members or raise the team size before solving.",
  "match.preSolve.heading": "Compose an optimal team from your candidate pool.",
  "match.preSolve.intro": "The Solver distributes your candidates across {teamSize} slots and optimizes against your requirement profile. You can re-run the calculation as often as you like.",
  "match.preSolve.noSizeYet": "no size chosen yet",
  "match.preSolve.personsCount": "{n} people",
  "match.preSolve.poolOnly": "{n} in pool",
  "match.preSolve.poolWithLocked": "{n} in pool · {locked} fix",
  "match.preSolve.solverRunning": "Solver running…",
  "match.preSolve.startSolver": "Start Solver",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team size set",
  "match.profilesLoadError": "Loading profiles: {message}",
  "match.publishToShare": "Publish as project in Share",
  "match.readOnlyBanner": "You can only view this match. Ask an admin or owner for write access.",
  "match.renameLabel": "Rename match",
  "match.recruiting.addBranche": "Industry",
  "match.recruiting.addCertificate": "Certificate",
  "match.recruiting.addEducation": "Education",
  "match.recruiting.addSkillHere": "Add expertise here",
  "match.recruiting.branchePlaceholder": "Choose industry",
  "match.recruiting.certificatePlaceholder": "e.g. AWS Solutions Architect",
  "match.recruiting.certificateTitle": "Required certificates",
  "match.recruiting.educationPlaceholder": "e.g. MSc Computer Science or vocational training",
  "match.recruiting.educationDegreePlaceholder": "Select degree",
  "match.recruiting.educationDegreeLabel": "Required degree",
  "match.recruiting.educationLevelInfo.aria": "Explain AI degree evaluation",
  "match.recruiting.educationLevelInfo.title": "Degree evaluation",
  "match.recruiting.educationLevelInfo.body": "Without AI, the selected catalogue entry is compared directly. With AI enabled, the model is instructed to also consider equivalent or clearly higher formal qualifications.",
  "match.recruiting.educationTitle": "Required education",
  "match.recruiting.experienceTitle": "Required work experience",
  "match.recruiting.expertiseTitle": "Required expertise (min.)",
  "match.recruiting.kann.tooltip": "Optional criterion: counts toward the fit score. Click to make it a must.",
  "match.recruiting.minYears": "min.",
  "match.recruiting.must.tooltip": "Must criterion: anyone who does not meet it is unqualified. Click to make it optional.",
  "match.recruiting.skillPlaceholder": "e.g. wound care",
  "match.recruiting.unrated": "Present",
  "match.recruiting.years": "Years",
  "match.recruiting.yearsUnit": "years",
  "match.removeAll": "Remove all",
  "match.requirements.aiMode.looseTooltip": "AI scores free text loosely. Click for strict mode.",
  "match.requirements.aiMode.off": "AI off",
  "match.requirements.aiMode.on": "AI on",
  "match.requirements.aiMode.strictTooltip": "Strict scoring. Click for AI interpretation.",
  "match.requirements.aria.cefrLevel": "Level",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Beginner",
  "match.requirements.cefr.A2": "A2 – Elementary",
  "match.requirements.cefr.B1": "B1 – Intermediate",
  "match.requirements.cefr.B2": "B2 – Upper intermediate",
  "match.requirements.cefr.C1": "C1 – Advanced",
  "match.requirements.cefr.C2": "C2 – Proficient",
  "match.requirements.cefr.NATIVE": "Native",
  "match.requirements.condition.annualSalary": "Annual salary",
  "match.requirements.otherUnchanged": "{count, plural, one {# other requirement stays} other {# other requirements stay}} unchanged.",
  "match.requirements.personDetails": "Person Details",
  "match.result.adjustRequirements": "Adjust requirements",
  "match.result.adjustTeamSize": "Team size",
  "match.result.age": "Age",
  "match.result.agentBudgetRole": "Keeps effort and costs in view",
  "match.result.agentCastingRole": "Finds complementary crew from the pool",
  "match.result.agentScheduleRole": "Plans dates, sprints, handovers",
  "match.result.agentsComingSoon": "Coming soon",
  "match.result.agentsIntro": "Agentic-AI assistants that accompany the team in the background – from scheduling to effort tracking. Not active yet, in preparation.",
  "match.result.agentsTitle": "Agents",
  "match.result.backToSelection": "← Close",
  "match.result.candidatesMeta": "{count, plural, one {# candidate} other {# candidates}}",
  "match.result.condition.age": "Age",
  "match.result.condition.annualSalary": "Salary",
  "match.result.condition.certificate": "Certificate",
  "match.result.condition.children": "Children",
  "match.result.condition.citizenship": "Citizenship",
  "match.result.condition.city": "Place of residence",
  "match.requirements.cityRadius": "Radius in kilometres",
  "match.requirements.cityRadiusDial": "Choose radius, drag outwards from the centre",
  "match.requirements.cityRadiusHint": "Drag up to 100 km, enter larger values above",
  "match.result.condition.country": "Country",
  "match.result.condition.department": "Department",
  "match.result.condition.driversLicense": "Driver's license",
  "match.result.condition.education": "Education",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: not {value}",
  "match.result.condition.experience": "Experience",
  "match.result.condition.expertise": "Expertise",
  "match.result.condition.gender": "Gender",
  "match.result.condition.industry": "Industry",
  "match.result.condition.language": "Language",
  "match.result.condition.location": "Work location",
  "match.result.condition.maritalStatus": "Marital status",
  "match.result.condition.nationality": "Nationality",
  "match.result.condition.present": "{label}: Present",
  "match.result.condition.presentActual": "Present",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "exactly",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "min.",
  "match.result.condition.thresholdNot": "not",
  "match.result.coverage": "Coverage",
  "match.result.dataHint": "Data note",
  "match.result.deleteAriaLabel": "Delete result “{name}”",
  "match.result.deleteConfirmBody": "The saved result <b>“{name}”</b> will be permanently removed. This action cannot be undone.",
  "match.result.deleteConfirmTitle": "Delete result?",
  "match.result.deleteFinal": "Delete permanently",
  "match.result.deleteTitle": "Delete",
  "match.result.deleting": "Deleting…",
  "match.result.dept": "Dept",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Discard",
  "match.result.discardUnsavedConfirm.message": "The computed result hasn't been saved yet and will be lost when you go back.",
  "match.result.discardUnsavedConfirm.title": "Discard unsaved result?",
  "match.result.dismissDataHint": "Dismiss data note",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} fulfilled",
  "match.result.emptyHint": "No data in the result.",
  "match.result.facts.mustViolated": "{count, plural, one {# must criterion is not met} other {# must criteria are not met}}.",
  "match.result.factsAndSkills": "Facts & Skills",
  "match.result.gender": "Gender",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "This match has no requirements in the Challenge step – so Coverage stays at 0 % and Facts & Skills remains empty. Define conditions to see how the team fulfils them.",
  "match.result.hintNoConditionsLabel": "No requirements defined",
  "match.result.hintNoDemographicsBody": "The people have no birth dates and no gender on file. Demographic chips and average age therefore stay hidden.",
  "match.result.hintNoDemographicsLabel": "No demographic data",
  "match.result.hintNoPowersBody": "The selected people have not self-assessed their powers. The Powers Score and element heatmap therefore show zero values. As soon as they maintain powers in their profile, the result fills in automatically.",
  "match.result.hintNoPowersLabel": "No power self-assessments",
  "match.result.historyLoading": "Saved results loading …",
  "match.result.historyTitle": "Saved results",
  "match.result.infeasibleBody": "The conditions contradict each other or your candidate pool is too small. Relax individual requirements, remove hard filters or enlarge the pool and start the Solver again.",
  "match.result.infeasibleLockedTitle": "Locked candidates block the solve",
  "match.result.infeasibleLockedHeading": "The locked members alone can't form a valid team.",
  "match.result.infeasibleLockedBody": "Too many people are locked in, or the locked members already violate a requirement. Unlock some members or raise the team size, then run the Solver again.",
  "match.result.infeasibleRelaxTitle": "Relax one of these must requirements",
  "match.result.infeasibleShortfall": "short by {shortfall}",
  "match.result.unlockMembers": "Unlock members",
  "match.result.infeasibleHeading": "The Solver couldn't compose a team that satisfies all requirements.",
  "match.result.infeasibleTitle": "No solution found",
  "match.result.insights.aiCriterionCandidates": "{count} candidates",
  "match.result.insights.aiMetShort": "{count} of them matched via AI",
  "match.result.insights.aiReasons": "{count} AI Reasons",
  "match.result.insights.aiShare": "AI share",
  "match.result.insights.bottlenecks": "Top 3 bottlenecks",
  "match.result.insights.radius": "Radius",
  "match.result.insights.radiusTitle": "{radius} km around {city}",
  "match.result.insights.radiusMapAria": "Radius map: candidates by distance to {city}",
  "match.result.insights.radiusInside": "{count} inside",
  "match.result.insights.radiusOutside": "{count} outside",
  "match.result.insights.radiusMissing": "{count} without distance",
  "match.result.insights.radiusHint": "Angle schematic, compressed distance scale",
  "match.result.insights.failCount": "{failed}/{total} excluded",
  "match.result.insights.fulfilledShort": "{met}/{total} fulfilled",
  "match.result.insights.gapShort": "{value} gap",
  "match.result.insights.hardestMust": "Knockout criterion",
  "match.result.insights.header": "Match analysis",
  "match.result.insights.koPassing": "meet it",
  "match.result.insights.noAiReasons": "No AI Reasons.",
  "match.result.insights.noBottleneck": "No notable bottlenecks.",
  "match.result.insights.noExclusion": "No must criterion excludes anyone.",
  "match.result.insights.noFulfilled": "No criterion is fulfilled.",
  "match.result.insights.averageShort": "avg {value}",
  "match.result.insights.medianShort": "median {value}",
  "match.result.insights.requiredShort": "target {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.personDetailsInfoAria": "Show person details note",
  "match.result.insights.personDetailsInfoBody": "Person details are not shown as analysis distributions. They remain visible in the candidate detail.",
  "match.result.insights.personDetailsInfoTitle": "Person details",
  "match.result.insights.reasonsShort": "{count} Reasons",
  "match.result.insights.recommendAi": "Manually review {count} AI Reasons across {candidates} candidates.",
  "match.result.insights.recommendBottleneck": "{criterion} is the strongest bottleneck; avg fulfilment {average}.",
  "match.result.insights.recommendData": "Fill profile values for {criterion}; {missing}/{total} evidence values are missing.",
  "match.result.insights.recommendMust": "Review or relax {criterion}; this must criterion excludes {failed}/{total} candidates.",
  "match.result.insights.recommendNone": "No immediate adjustment needed.",
  "match.result.insights.recommendation": "Recommendation",
  "match.result.insights.textDistribution": "top value {value} ({count}/{present}) · {distinct} variants",
  "match.result.insights.topFulfilled": "Top 3 fulfilled criteria",
  "match.result.loadFailed": "Result could not be loaded (id {id}). Check the browser console.",
  "match.result.maxRawHint": "/100 (max raw)",
  "match.result.noRequirementsEmpty": "This match definition has no requirements – Facts & Skills stays empty.",
  "match.result.openFlag": "open",
  "match.result.openProfileTitle": "{name} – open profile",
  "match.result.powerClusters": "Power Clusters",
  "match.result.powersScore": "Powers Score",
  "match.result.powersTop": "Powers · Top",
  "match.result.ranking.aiChip": "AI Reason",
  "match.result.ranking.aiChipTitle": "Reason from the AI evaluation",
  "match.result.ranking.assessment.fazit": "Verdict",
  "match.result.ranking.assessment.negative": "Negative",
  "match.result.ranking.assessment.positive": "Positive",
  "match.result.ranking.assessment.title": "Smycles assessment",
  "match.result.ranking.collapseAll": "Collapse all",
  "match.result.ranking.expandAll": "Expand all",
  "match.result.ranking.kindBasics": "Person Details",
  "match.result.ranking.kindCertificate": "Certificate",
  "match.result.ranking.kindEducation": "Education",
  "match.result.ranking.kindExperience": "Experience",
  "match.result.ranking.kindExpertise": "Expertise",
  "match.result.ranking.kindLanguage": "Language",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.lenientMatchHint": "Fulfilled via lenient requirement check: expertise present, required level not verified.",
  "match.result.ranking.dotFulfilled": "Fulfilled",
  "match.result.ranking.dotPartial": "Partially fulfilled",
  "match.result.ranking.dotUnfulfilled": "Not fulfilled",
  "match.result.ranking.emptyHintLabel": "Note",
  "match.result.ranking.emptyFilteredTab": "No {requirement} criteria under “{tab}”.",
  "match.result.ranking.emptyShowAll": "Show all criteria",
  "match.result.ranking.emptySwitchTab": "Switch to “{tab}”",
  "match.result.ranking.emptyTab": "There are no criteria under “{tab}”.",
  "match.result.ranking.tabNameFulfilled": "Fulfilled",
  "match.result.ranking.tabNameLenient": "Leniently fulfilled",
  "match.result.ranking.tabNameUnfulfilled": "Not fulfilled",
  "match.result.ranking.lenientTab": "Leniently fulfilled ({count})",
  "match.result.ranking.must": "Must",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.mustTitle": "Must criteria",
  "match.result.ranking.mustNone": "No must criteria",
  "match.result.ranking.mustInfoTitle": "Must criteria",
  "match.result.ranking.mustInfoAria": "Show must criteria",
  "match.result.ranking.mustFormula": "Must criteria are hard gates: every one has to be met.",
  "match.result.ranking.mustMetSummary": "Met: {met}/{total}",
  "match.result.ranking.criterionMet": "met",
  "match.result.ranking.criterionFailed": "not met",
  "match.result.ranking.kannTitle": "Optional criteria",
  "match.result.ranking.scoreCriteriaValue": "Optional criteria: {criteria}",
  "match.result.ranking.filterAll": "All",
  "match.result.ranking.filterMust": "Must",
  "match.result.ranking.filterKann": "Optional",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.powerFitSoon": "Power-Fit view is coming.",
  "match.result.ranking.noAssessment": "No Smycles assessment available.",
  "match.result.ranking.noCriteria": "No criteria defined",
  "match.result.ranking.noMustHint": "Candidates end up here when they miss a must criterion (lock) or their score falls below the C threshold.",
  "match.result.ranking.openProfile": "Open profile",
  "match.result.ranking.optional": "Optional",
  "match.result.ranking.powerFitTooltip": "Power-Fit: weighted average of this person's own power values.",
  "match.result.ranking.scoreFormula": "Score = average of the optional (Kann) criteria.",
  "match.result.ranking.scoreInfoAria": "Show score calculation",
  "match.result.ranking.scoreInfoTitle": "Calculation",
  "match.result.ranking.scoreMustGate": "Must criteria remain a hard gate on top.",
  "match.result.ranking.sortBy": "Sort by",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Requirements-Fit",
  "match.result.ranking.thresholdAAria": "Threshold between A and B",
  "match.result.ranking.thresholdBAria": "Threshold between B and C",
  "match.result.ranking.thresholdCAria": "Lower bound for C",
  "match.result.ranking.thresholdsLabel": "Thresholds",
  "match.result.ranking.unqualified": "Criteria not met",
  "match.result.ranking.yearsValue": "{years, plural, one {# year} other {# years}}",
  "match.result.rankingHeader": "Ranking",
  "match.result.reviewSubtitle": "Optimized for your requirement profile – transparent, explainable, exportable.",
  "match.result.saveResult": "Save result",
  "match.result.savedResultLabel": "Saved result · {name}",
  "match.result.savedSubtitle": "You're viewing a saved result of this Match.",
  "match.result.solverErrorBody": "Genesis rejected the calculation. This currently happens when the match design contains fields the backend doesn't (yet) know. Try again shortly or report the case with the correlation ID below.",
  "match.result.solverErrorHeading": "The backend didn't finish the Solver.",
  "match.result.solverErrorTitle": "Solver error",
  "match.result.solverNotRun": "Solver hasn't run yet.",
  "match.result.solverRunning": "Solver running …",
  "match.result.teamHeader": "Team · {count, plural, one {# person} other {# people}}",
  "match.result.teamPowers": "Team Powers",
  "match.result.teamSizeMeta": "Team size {count}",
  "match.result.unnamed": "unnamed",
  "match.save.eyebrow": "Save result",
  "match.save.failed": "Save failed",
  "match.save.modeAssess": "Assess",
  "match.save.modeOptimize": "Optimize",
  "match.save.modeRank": "Rank",
  "match.save.note": "Note",
  "match.save.notePlaceholder": "Optional – context, assumptions, next steps …",
  "match.save.off": "off",
  "match.save.on": "on",
  "match.save.previewAndNote": "Preview & note",
  "match.save.resultName": "Result name",
  "match.save.retry": "Try again",
  "match.save.saved": "Saved",
  "match.save.saving": "Saving…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Conditions",
  "match.save.statMode": "Mode",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Target",
  "match.save.teamCount": "Team · {count, plural, one {# person} other {# people}}",
  "match.settingsEyebrow": "Match settings",
  "match.shortDescPlaceholder": "In one sentence: what, what for?",
  "match.smyclesAi": "Requirements Prompt",
  "match.step.challenge": "Challenge",
  "match.step.people": "Team players",
  "match.step.peopleRank": "Candidates",
  "match.step.result": "Result",
  "match.teamPowers": "Team Powers",
  "match.teamProfile": "Team Profile",
  "match.teamProfileBalanced": "Balanced",
  "match.teamProfileCustom": "Custom",
  "match.teamProfileModifiedSuffix": " · modified",
  "match.teamReqsSection": "Team requirements",
  "match.teamSizeSection": "Team size",
  "match.titlePlaceholder": "e.g. Set crew BTL · Q2 2026",
  "match.tour.create.desc": "This button creates a new match and opens the editor, where you describe what you need and the solver proposes the team.",
  "match.tour.create.title": "Create a new match",
  "match.tour.label": "Match",
  "match.tour.list.desc": "All your matches live here. Click a card to reopen it and continue where you left off.{names}",
  "match.tour.list.names": "Currently: {list}.",
  "match.tour.list.title": "Your matches",
  "match.tour.summary": "This is the Match area: you put teams together from people and requirements. You have {count} matches so far.",
  "match.unnamedMatch": "Unnamed match",
  "match.unnamedProject": "Unnamed project",
  "match.weightLevel.high": "High",
  "match.weightLevel.low": "Low",
  "match.weightLevel.medium": "Medium",
  "match.weightLevel.none": "Not relevant",
  "match.workflow.challengeSubtitle": "Describe your project above – the AI derives team size, requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleNoTeamSize": "Describe your project above – the AI derives requirements and powers from it. Below you review the result and fine-tune small details.",
  "match.workflow.challengeSubtitleRank": "Describe the role or open position above – the AI derives the requirements a candidate should meet. Below you review the result and fine-tune small details.",
  "match.workflow.deleteConfirm.confirm": "Delete",
  "match.workflow.deleteConfirm.message": "The Match will be permanently removed from genesis. This action cannot be undone.",
  "match.workflow.deleteConfirm.title": "Delete Match?",
  "match.workflow.deleteTitle": "Delete match",
  "match.workflow.modeAssess": "Assess",
  "match.workflow.modeIndicatorTitle": "Mode (fixed at creation)",
  "match.workflow.modeOptimize": "Optimize",
  "match.workflow.modeRank": "Rank",
  "match.workflow.nextTo": "Continue to {label}",
  "match.workflow.prevTo": "Back to {label}",
  "match.workflow.settingsTitle": "Match settings",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "You are editing the match \"{name}\", currently on the \"{step}\" workflow step with {candidates} candidates and {results} saved results. Work through the steps from requirements to the solved team.",
  "matchDetail.tour.untitled": "untitled match",
  "model.connected": "Connected",
  "model.keyAriaLabel": "{provider} API key",
  "model.providerSub": "The upstream model stack. Model kinds resolve to this provider's concrete models.",
  "model.providerTitle": "Provider",
  "model.resolvedModels": "Resolved models",
  "model.saveError": "Couldn't save model settings – try again.",
  "model.saveError.forbidden": "You need admin rights to change the model configuration.",
  "model.saveError.notConfigured": "Model configuration isn't enabled on this server.",
  "model.saveError.unauthorized": "Your session has expired – sign in again.",
  "model.saveError.upstream": "Couldn't reach the configuration store – try again.",
  "model.saved": "Settings saved – may take up to 60 seconds to take effect.",
  "nav.community": "Community",
  "nav.logout": "Logout",
  "nav.mainLandmark": "Main",
  "nav.map": "Map",
  "nav.openMenu": "Open menu",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profile",
  "nav.service": "Documents",
  "nav.settings": "Settings",
  "nav.watch": "Watch",
  "personFilter.addFilter": "+ Add filter",
  "personFilter.allFilters": "All filters",
  "personFilter.frequent": "Frequent",
  "personFilter.heading": "Team Player filters{count, plural, =0 {} other { · # active}}",
  "pinboard.tour.controls.desc": "Search pins by name, change the sort order, or filter to pins that are not in any group yet.",
  "pinboard.tour.controls.title": "Search & sort",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in the current view. Click a card to open it, use \"+ Add\" to put it into groups, or the trash icon to unpin it.",
  "pinboard.tour.grid.title": "Your pinned items",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Switch between your pinned people ({people}), posts ({posts}) and projects ({projects}), and pick a pin group below. Drag a card onto a group to file it there.",
  "pinboard.tour.sidebar.title": "Types & groups",
  "pinboard.tour.summary": "This is your pinboard with everything you saved: {people} people, {posts} posts and {projects} projects.",
  "power.name.Abs": "Abstraction",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomy",
  "power.name.Awe": "Self-Perception",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Concentration",
  "power.name.Cop": "Tolerance",
  "power.name.Cou": "Courage",
  "power.name.Cur": "Curiosity",
  "power.name.Dil": "Diligence",
  "power.name.Emp": "Empathy",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Belief",
  "power.name.Fid": "Fidelity",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Joy",
  "power.name.Lan": "Language",
  "power.name.Min": "Mindfulness",
  "power.name.Pas": "Passion",
  "power.name.Per": "Perception",
  "power.name.Psc": "Perseverance",
  "power.name.Rpy": "Responsibility",
  "power.name.Str": "Strategy",
  "power.tag.Co": "Communication",
  "power.tag.Fo": "Future Orientation",
  "power.tag.In": "Inventiveness",
  "power.tag.Re": "Resilience",
  "power.tag.Ro": "Result Orientation",
  "power.tag.Ts": "Teamability",
  "profile.fields.addCountry": "+ Country",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Change photo",
  "profile.fields.removePhoto": "Remove photo",
  "profile.page.add.certificate": "Add certificate",
  "profile.page.add.education": "Add education",
  "profile.page.add.experience": "Add work experience",
  "profile.page.add.expertise": "Add skill",
  "profile.page.add.language": "Add language",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} years",
  "profile.page.allLabel": "All:",
  "profile.page.businessCard": "Business card",
  "profile.page.businessCardRoleHint": "Taken from Details › Company › Job title",
  "profile.page.details": "Details",
  "profile.page.details.company": "Company",
  "profile.page.details.personal": "Personal",
  "profile.page.editVisibility": "Edit visibility",
  "profile.page.empty.certificates": "No certificates",
  "profile.page.empty.education": "No education",
  "profile.page.empty.experience": "No work experience",
  "profile.page.empty.expertise": "No skills",
  "profile.page.empty.languages": "No languages",
  "profile.page.error.certificateNameRequired": "Name is required.",
  "profile.page.error.fieldOfStudyRequired": "Field of study is required.",
  "profile.page.error.jobTitleRequired": "Job title is required.",
  "profile.page.error.languageLevelRequired": "Please choose a level for the foreign language.",
  "profile.page.error.nameRequired": "First name and last name are required.",
  "profile.page.error.saveEntries": "Could not save entries",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# entry could not be saved.} other {# entries could not be saved.}}",
  "profile.page.error.saveFailed": "Saving failed.",
  "profile.page.error.savePerson": "Could not save person",
  "profile.page.error.startDateRequired": "Start date is required.",
  "profile.page.familyName.placeholder": "Last name",
  "profile.page.field.activities.label": "Main tasks",
  "profile.page.field.activities.placeholder": "e.g. Code reviews",
  "profile.page.field.cefr": "Level (CEFR)",
  "profile.page.field.certificateName.label": "Name",
  "profile.page.field.certificateName.placeholder": "e.g. AWS Solutions Architect",
  "profile.page.field.country": "Country",
  "profile.page.field.degree.label": "Degree",
  "profile.page.field.degree.placeholder": "Choose degree",
  "profile.page.field.degree.search": "Search degree",
  "profile.page.field.degree.none": "No degree selected",
  "profile.page.field.department": "Department",
  "profile.page.field.employer.label": "Employer",
  "profile.page.field.employer.placeholder": "e.g. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Name",
  "profile.page.field.expertiseName.placeholder": "e.g. Kubernetes",
  "profile.page.field.field.label": "Field of study",
  "profile.page.field.field.placeholder": "e.g. Computer science",
  "profile.page.field.from": "From",
  "profile.page.field.industry": "Industry",
  "profile.page.field.institution": "Educational institution",
  "profile.page.field.issueDate": "Issue date",
  "profile.page.field.jobTitle.label": "Job title",
  "profile.page.field.jobTitle.placeholder": "e.g. Software developer",
  "profile.page.field.language.label": "Language",
  "profile.page.field.language.placeholder": "Choose language",
  "profile.page.field.level": "Level",
  "profile.page.field.location": "Location",
  "profile.page.field.nativeSpeaker.label": "Native language",
  "profile.page.field.nativeSpeaker.placeholder": "Native language",
  "profile.page.field.to": "To",
  "profile.page.givenName.placeholder": "First name",
  "profile.page.hideVisibility": "Hide visibility",
  "profile.page.inCommunity": "In community",
  "profile.page.inPins": "In pins",
  "profile.page.label.apartment": "Apartment",
  "profile.page.label.birthday": "Birthday",
  "profile.page.label.childCount": "Number of children",
  "profile.page.label.citizenship": "Citizenship",
  "profile.page.label.city": "Place of residence",
  "profile.page.label.contractType": "Contract type",
  "profile.page.label.country": "Country",
  "profile.page.label.countryState": "State / region",
  "profile.page.label.currentActivity": "Current activity",
  "profile.page.label.currentEmployer": "Employer",
  "profile.page.label.currentTasks": "Main tasks",
  "profile.page.label.drivingLicence": "Driving licence",
  "profile.page.label.email": "Email",
  "profile.page.label.gender": "Gender",
  "profile.page.label.houseNumber": "House number",
  "profile.page.label.jobDepartment": "Department",
  "profile.page.label.jobLocation": "Work location",
  "profile.page.label.jobTitle": "Job title",
  "profile.page.label.maritalStatus": "Marital status",
  "profile.page.label.miscellaneous": "Other",
  "profile.page.label.nationality": "Nationality",
  "profile.page.label.phone": "Phone",
  "profile.page.label.profession": "Profession",
  "profile.page.label.street": "Street",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Working time",
  "profile.page.label.zipCode": "Postal code",
  "profile.page.loadFailed": "Profile could not be loaded",
  "profile.page.loadFailedHint": "Please reload the page or sign in again.",
  "profile.page.notFound": "Profile not found",
  "profile.page.notFoundHint": "This profile does not exist or has not been shared with you.",
  "profile.page.openChat": "Open chat",
  "profile.page.section.certificates": "Certificates",
  "profile.page.section.education": "Education",
  "profile.page.section.experience": "Work experience",
  "profile.page.section.expertise": "Expertise",
  "profile.page.section.languages": "Languages",
  "profile.page.serviceMenu": "Service",
  "profile.page.startChat": "Send message",
  "profile.page.summary": "Summary",
  "profile.page.warning.childCountMax": "The number of children cannot exceed 20.",
  "profile.rows.done": "Done",
  "profile.rows.level": "Level: {level}",
  "profile.rows.nativeSpeaker": "Native speaker",
  "profile.rows.noLevel": "No level",
  "profile.rows.today": "today",
  "profile.sidebars.errorPrefix": "Error: {message}",
  "profile.sidebars.favorites": "Favorites",
  "profile.sidebars.loading": "loading…",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Self-assessment",
  "profile.sidebars.smartAnalysis": "Smart analysis",
  "profile.skills.addAtLevel": "Add skill at this level",
  "profile.skills.unrated": "Unrated",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Classic",
  "profile.tour.about.desc": "Your summary text, your personal and company details and your {languages} languages. Click any field to edit it in place.",
  "profile.tour.about.title": "Summary, details and languages",
  "profile.tour.card.desc": "Click any field (name, phone, email, country, city) to edit it in place; changes are collected and saved via the save bar.{missing}",
  "profile.tour.card.missingHint": "Some of your contact fields are still empty.",
  "profile.tour.card.title": "Your business card",
  "profile.tour.cv.desc": "{experiences} work experiences, {educations} educations, {skills} skills and {certificates} certificates. Add new entries here or click an existing one to edit it.",
  "profile.tour.cv.title": "Your CV entries",
  "profile.tour.label": "Save Profile",
  "profile.tour.powers.desc": "Your strongest powers at a glance. Click one to see its detail page, or assess more of them over in Grow.",
  "profile.tour.powers.title": "Your powers",
  "profile.tour.service.desc": "AI helpers and data services for your profile: extract powers and skills, import a CV or LinkedIn profile, generate a CV and export your data.",
  "profile.tour.service.title": "Service menu",
  "profile.tour.summary": "This is your own profile with {count} CV entries. Almost every field is editable right on the page.",
  "profile.tour.visibility.desc": "This toggle reveals a share switch next to every field and entry, so you decide exactly what other people can see of your profile.",
  "profile.tour.visibility.title": "Edit visibility",
  "profileExtraction.abort": "Abort extraction",
  "profileExtraction.abortTip": "Still extracting - you can keep waiting, or abort and try again with the same document. Nothing has been saved yet.",
  "profileExtraction.analysing": "Extracting profile data from your document - this can take up to two minutes...",
  "profileExtraction.dropZone": "Drag a document here or click to upload",
  "profileExtraction.dropZoneHint": "CV, LinkedIn export, application form … · PDF, DOCX, image · max. 10 MB",
  "profileExtraction.elapsed": "Elapsed time: {time}",
  "profileExtraction.fileTooLarge": "File is too large (max. 10 MB).",
  "profileExtraction.noResult": "The document could not be analysed.",
  "profileExtraction.timeout": "Analysis is taking too long. Please try again.",
  "profileExtraction.nothingNew": "Nothing new found – your profile already covers this document.",
  "profileExtraction.ready": "We found details to review in {file}.",
  "profileExtraction.review": "Review changes",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Unsupported file type.",
  "referenceData.add": "Add",
  "referenceData.cancel": "Cancel",
  "referenceData.confirmDelete.message": "The entry is removed for good and will no longer be offered in profiles and Match requirements.",
  "referenceData.confirmDelete.title": "Delete “{label}”?",
  "referenceData.contractType.add": "New contract type",
  "referenceData.contractType.empty": "No contract types yet.",
  "referenceData.contractType.sub": "Managed list of contract types.",
  "referenceData.contractType.title": "Contract types",
  "referenceData.degree.add": "New degree",
  "referenceData.degree.empty": "No degrees yet.",
  "referenceData.degree.sub": "Managed list of academic degrees for education entries.",
  "referenceData.degree.title": "Degrees",
  "referenceData.delete": "Delete",
  "referenceData.duplicate": "This entry already exists.",
  "referenceData.edit": "Edit",
  "referenceData.gender.add": "New gender",
  "referenceData.gender.empty": "No entries.",
  "referenceData.gender.sub": "Managed list of genders.",
  "referenceData.gender.title": "Genders",
  "referenceData.industry.add": "New industry",
  "referenceData.industry.empty": "No industries yet.",
  "referenceData.industry.sub": "Managed list of industries for profiles and Match requirements.",
  "referenceData.industry.title": "Industries",
  "referenceData.jobDepartment.add": "New department",
  "referenceData.jobDepartment.empty": "No departments yet.",
  "referenceData.jobDepartment.sub": "Managed list of departments for profiles and Match requirements.",
  "referenceData.jobDepartment.title": "Departments",
  "referenceData.jobLocation.add": "New work location",
  "referenceData.jobLocation.empty": "No work locations yet.",
  "referenceData.jobLocation.sub": "Managed list of work locations for profiles and Match requirements.",
  "referenceData.jobLocation.title": "Work locations",
  "referenceData.loading": "Loading…",
  "referenceData.maritalStatus.add": "New marital status",
  "referenceData.maritalStatus.empty": "No entries.",
  "referenceData.maritalStatus.sub": "Managed list of marital statuses.",
  "referenceData.maritalStatus.title": "Marital statuses",
  "referenceData.save": "Save",
  "referenceData.workingTimeModel.add": "New working-time model",
  "referenceData.workingTimeModel.empty": "No working-time models yet.",
  "referenceData.workingTimeModel.sub": "Managed list of working-time models.",
  "referenceData.workingTimeModel.title": "Working-time models",
  "save.addToCollection.adding": "Adding…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> was added to <b>{target}</b> in <b>{group}</b>.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> was added to <b>{target}</b> (without group).",
  "save.addToCollection.error": "Could not add. Please try again.",
  "save.addToCollection.goToTarget": "To {target}",
  "save.addToCollection.groupLabel": "Group",
  "save.addToCollection.noGroupPlaceholder": "Without group",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "Add {name} to {target}",
  "save.careerGraph.active": "Active",
  "save.careerGraph.done": "Done",
  "save.careerGraph.emptyLabel": "No career or education entries",
  "save.careerGraph.mainTasks": "Main tasks",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Classic",
  "save.careerGraph.showMainTasks": "Show main tasks",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "today",
  "save.careerGraph.todayMarker": "TODAY",
  "save.careerGraph.visibilityPrivate": "Private",
  "save.careerGraph.visibilityPublic": "Public",
  "save.careerGraph.visibilityShared": "Shared",
  "save.collection.addToGroup": "Add to „{name}”",
  "save.collection.allGroups": "All",
  "save.collection.allLabel": "All",
  "save.collection.deleteGroup": "Delete group",
  "save.collection.errorPrefix": "Error: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "Open {title}",
  "save.collection.removeFromGroup": "Remove from „{name}”",
  "save.collection.rename": "Rename",
  "save.collection.renameGroup": "Rename group",
  "save.collection.searchPlaceholder": "Search…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Add",
  "save.community.createError": "Community could not be created.",
  "save.community.dailyQuotaExceeded": "Daily limit reached. Please try again later.",
  "save.community.deleteCommunity": "Delete community",
  "save.community.deleteCompletely": "Delete completely",
  "save.community.deleteConfirm": "Delete \"{name}\"? The contacts are kept, only the grouping is removed.",
  "save.community.deleteContactPrompt": "Delete \"{name}\" from your contacts and all communities?",
  "save.community.deleteError": "Community could not be deleted.",
  "save.community.description": "Group your contacts. Select a community on the left and drag contacts into it or add them to one or more communities via \"Add\".",
  "save.community.emptyAllGrouped": "All contacts are in communities.",
  "save.community.emptyCommunity": "No one in this community yet. Drag contacts here or use \"Add\".",
  "save.community.emptyNoContacts": "No contacts yet.",
  "save.community.headerCount": "{count, plural, one {# contact} other {# contacts}}",
  "save.community.limitReached": "You have reached the maximum of {limit} communities.",
  "save.community.moveFailed": "Move failed.",
  "save.community.namePlaceholder": "Community name …",
  "save.community.newCommunity": "New community",
  "save.community.removeContact": "Remove contact",
  "save.community.removeContactError": "Contact could not be removed.",
  "save.community.removeFromCommunityFailed": "Removing from the community failed.",
  "save.community.removeFromCommunityPrompt": "Remove \"{name}\" from \"{community}\" (stays your contact and in other communities) or delete completely from your contacts and all communities?",
  "save.community.removeFromGroup": "Remove from group",
  "save.community.renameCommunity": "Rename community",
  "save.community.renameError": "Community could not be renamed.",
  "save.community.saveError": "Community could not be saved.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Contacts without a community",
  "save.extraction.analysing": "Analysing …",
  "save.extraction.analysisComplete": "Analysis complete.",
  "save.extraction.analysisFailed": "Analysis failed.",
  "save.extraction.analysisFailedWithReason": "Analysis failed ({reason}).",
  "save.extraction.stillRunning": "The analysis is taking a while and keeps running in the background. You’ll get a notification when it’s done.",
  "save.extraction.runningInBackground": "Running in the background - you can close this and keep working. You’ll be notified when it’s done.",
  "save.extraction.done": "Done",
  "save.extraction.dropZone": "Drag a file here or click to upload",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, images · max. 10 MB per file",
  "save.extraction.duplicateWarning": "Already exists in Documents - the stored document is analysed, no re-upload.",
  "save.extraction.expertiseFallback": "Expertise",
  "save.extraction.fileTooLarge": "“{name}” is too large (max. 10 MB per file).",
  "save.extraction.fromDocuments": "From Documents",
  "save.extraction.newFile": "New file",
  "save.extraction.newPowersHeading": "Newly detected powers{count, plural, =0 {} other { (#)}}",
  "save.extraction.newSkillsHeading": "Newly detected expertise{count, plural, =0 {} other { (#)}}",
  "save.extraction.noDocuments": "No documents available.",
  "save.extraction.noFolder": "No folder",
  "save.extraction.noNewPowers": "No changes - the analysis produced no new power values.",
  "save.extraction.noNewSkills": "No new entries - everything was probably already in your expertise.",
  "save.extraction.notAnalyzable": "Not analysable",
  "save.extraction.notSignedIn": "Not signed in - upload not possible.",
  "save.extraction.nothingSelected": "Nothing selected",
  "save.extraction.persistUploads": "Save uploaded files in Documents",
  "save.extraction.pipelineCounts": "{processed} processed · {skipped} skipped · {errored} errors",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powers": "Powers",
  "save.extraction.selectAllInGroup": "Select all in {group}",
  "save.extraction.selectedCount": "{total, plural, one {# document selected} other {# documents selected}}",
  "save.extraction.skills": "Skills",
  "save.extraction.startAnalysis": "Start analysis",
  "save.extraction.statusLine": "Status: {status}",
  "save.extraction.toggleCollapse": "Expand/collapse",
  "save.extraction.unsupportedType": "“{name}” can’t be analysed. Supported: PDF, Word, Excel and images.",
  "save.extraction.uploadFailedDuplicate": "Upload failed. A document with this name probably already exists.",
  "save.landing.cockpitLabel": "Cockpit · Data flow at a glance",
  "save.landing.cockpitRight": "Visibility, Consent, Sync",
  "save.landing.communityCount": "{count, plural, one {# community} other {# communities}}",
  "save.landing.communityLabel": "Community",
  "save.landing.complete": "complete",
  "save.landing.contacts": "Contacts",
  "save.landing.enrichProfile": "Complete profile",
  "save.landing.fieldBio": "Bio",
  "save.landing.fieldCity": "Place of residence",
  "save.landing.fieldContactData": "Contact details",
  "save.landing.fieldEducation": "Education",
  "save.landing.fieldExperience": "Work experience",
  "save.landing.fieldExpertise": "Expertise",
  "save.landing.fieldLanguages": "Languages",
  "save.landing.fieldProfession": "Profession",
  "save.landing.heroBody": "Your personal vault, transparent, verified, exportable. Profiles, powers, career, contacts, pins and favorites in one place.",
  "save.landing.heroCta": "Open my Vault",
  "save.landing.heroSubtitleLine1": "Own your data.",
  "save.landing.heroSubtitleLine2": "Share on your terms.",
  "save.landing.identitySnapshotLabel": "Identity Snapshot",
  "save.landing.identitySnapshotRight": "Your vault at a glance",
  "save.landing.lastVisitor": "last: {name}",
  "save.landing.noContactsYet": "no contacts yet",
  "save.landing.noPinsYet": "nothing pinned yet",
  "save.landing.noVisitsYet": "no views yet",
  "save.landing.openColon": "Open",
  "save.landing.pinsLabel": "Pins",
  "save.landing.pinsSaved": "saved",
  "save.landing.powerMap": "Power Map",
  "save.landing.powerMapLabel": "Your Power Map · Ready for MATCH",
  "save.landing.profileCompletenessLabel": "Profile completeness",
  "save.landing.profileVisitorsLabel": "Profile visitors",
  "save.landing.vaultModules": "Vault modules",
  "save.landing.vaultModulesLabel": "Your Vault · 4 modules",
  "save.landing.viewAll82": "View all 82",
  "save.landing.viewCommunities": "View communities",
  "save.landing.viewPins": "View pins",
  "save.landing.visibilityMatrix": "Visibility Matrix & Recent Activity",
  "save.pinGroupDialog.createFailed": "The group could not be created.",
  "save.pinGroupDialog.invalidName": "Invalid name.",
  "save.pinGroupDialog.limitReached": "You have reached the maximum of {limit} groups.",
  "save.pinGroupDialog.placeholder": "e.g. Mentors",
  "save.pinGroupDialog.renameFailed": "The group could not be renamed.",
  "save.pinGroupDialog.submitCreate": "Create",
  "save.pinGroupDialog.titleCreate": "New group",
  "save.pinGroupDialog.titleRename": "Rename group",
  "save.pinGroupDialog.tryAgain": "Please try again.",
  "save.pinGroupSidebar.addGroup": "+ Group",
  "save.pinGroupSidebar.deleteMessage": "Delete “{name}”? The pins remain, only the grouping is removed.",
  "save.pinGroupSidebar.deleteTitle": "Delete group",
  "save.pinGroupSidebar.tabPerson": "People",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projects",
  "save.pinboardPage.description": "Drag a card onto a group on the left, or add it to one or more groups via “Add”. Dragging onto “All” removes it from the current group.",
  "save.pinboardPage.emptyAllGrouped": "All pinned {typeLabel} are in groups.",
  "save.pinboardPage.emptyNoneInView": "No pinned {typeLabel} in this view.",
  "save.pinboardPage.itemFallback": "Entry",
  "save.pinboardPage.openItem": "Open {name}",
  "save.pinboardPage.removeFromGroup": "Remove from group",
  "save.pinboardPage.removeFromGroupMessage": "Remove “{title}” from “{group}” (stays pinned and in other groups) or unpin completely?",
  "save.pinboardPage.removePin": "Remove pin",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "People",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projects",
  "save.pinboardPage.ungroupedLabel": "Pins without a group",
  "save.pinboardPage.unpin": "Unpin",
  "save.pinboardPage.unpinCompletely": "Unpin completely",
  "save.pinboardPage.unpinMessage": "Unpin “{title}”?",
  "save.tour.community.desc": "You have {contacts} contacts in {communities} communities. Click the tile to group and manage them.",
  "save.tour.community.title": "Community",
  "save.tour.completeness.desc": "Your profile is {pct}% complete.{missing} Click the tile to fill in the gaps.",
  "save.tour.completeness.done": "Everything is filled in.",
  "save.tour.completeness.missing": "Still open: {fields}.",
  "save.tour.completeness.title": "Profile completeness",
  "save.tour.label": "Save",
  "save.tour.pins.desc": "{count} pinned items: people, posts and projects you saved. Click the tile to open your pinboard.",
  "save.tour.pins.title": "Pins",
  "save.tour.summary": "This is your Save area, your personal data vault. Your profile is {pct}% complete. Let me show you your vault at a glance.",
  "save.tour.visitors.desc": "{count} recent profile visitors{last}. Open a name to see who is interested in you.",
  "save.tour.visitors.title": "Profile visitors",
  "search.activeCount": "{count} active",
  "search.allFiltersAdded": "All filters added",
  "search.any": "Any",
  "search.chipType": "Type",
  "search.clear": "Clear search",
  "search.confirmRemoveFromGroup": "Remove?",
  "search.discoverHeading": "Discover",
  "search.done": "Done",
  "search.either": "Either",
  "search.errorPrefix": "Error: {message}",
  "search.extended": "Extended search",
  "search.eyebrow": "Search",
  "search.fieldAge": "Age",
  "search.fieldChildren": "Number of children",
  "search.fieldCitizenship": "Citizenship",
  "search.fieldCity": "Place of residence",
  "search.fieldCountry": "Country",
  "search.fieldDepartment": "Department",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "First name",
  "search.fieldGender": "Gender",
  "search.fieldIndustry": "Industry",
  "search.fieldJobTitle": "Job title",
  "search.fieldLanguages": "Languages",
  "search.fieldLastName": "Last name",
  "search.fieldLocation": "Work location",
  "search.fieldMaritalStatus": "Marital status",
  "search.fieldNationality": "Nationality",
  "search.filterHeading": "{type} filters",
  "search.flagCommented": "Commented",
  "search.flagOwner": "Owner",
  "search.flagPinned": "Pinned",
  "search.flagRated": "Rated",
  "search.flagSignedUp": "Interested",
  "search.groupPosts": "Posts",
  "search.groupProjects": "Projects",
  "search.groupTeamplayers": "Team players",
  "search.hide": "Hide ▴",
  "search.no": "No",
  "search.noFilters": "No filters set.",
  "search.noResults": "No matches",
  "search.openChat": "Open chat",
  "search.pin": "Pin",
  "search.pinInto": "Pin into {name}",
  "search.pinNoGroup": "Pin (no group)",
  "search.placeholder": "Search team players, projects, posts …",
  "search.placeholderPerson": "Name, job title …",
  "search.placeholderShared": "Title, description …",
  "search.queryLabel": "Search term",
  "search.rangeTo": "to",
  "search.removeFieldLabel": "Remove {field}",
  "search.removeFromGroup": "Remove from {name}",
  "search.reset": "Reset",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} of {total} {type}",
  "search.search": "Search",
  "search.searching": "Searching …",
  "search.show": "Show ▾",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tour.filters.desc": "Build structured filters here and combine them with the free-text search term above, then hit Search. {count} filters are active right now.",
  "search.tour.filters.emptyDesc": "Build structured filters here and combine them with the free-text search term above, then hit Search. No filters are set right now.",
  "search.tour.filters.title": "Filters",
  "search.tour.label": "Search",
  "search.tour.results.desc": "The matches appear here, currently {summary}. Click a result to open it; scrolling down loads more.",
  "search.tour.results.title": "Results",
  "search.tour.summary": "This is the extended search. Find people or shared projects and posts with structured filters. You are currently searching {type}.",
  "search.tour.typeToggle.desc": "Switch the search category: Teamplayer finds people, Share finds projects and posts. Each category has its own filters.",
  "search.tour.typeToggle.title": "What to search",
  "search.typeAll": "All",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projects",
  "search.unpin": "Unpin",
  "search.useExtended": "Use extended search",
  "search.writeMessage": "Write a message",
  "search.yes": "Yes",
  "secretInput.hide": "Hide value",
  "secretInput.show": "Show value",
  "service.docItemRow.download": "Download",
  "service.docItemRow.newBadge": "New",
  "service.docItemRow.open": "Open",
  "service.docItemRow.rename": "Click to rename",
  "service.docItemRow.selectAriaLabel": "Select {name}",
  "service.docItemRow.sourceLabel": "Source: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator draft",
  "service.docPreviewCard.download": "Download",
  "service.docPreviewCard.newBadge": "New",
  "service.docPreviewCard.open": "Open",
  "service.docPreviewCard.rename": "Click to rename",
  "service.docPreviewCard.selectAriaLabel": "Select {name}",
  "service.extRename.ariaLabel": "Rename",
  "service.filterBuilder.addFilter": "+ Add filter",
  "service.filterBuilder.all": "All",
  "service.filterBuilder.allFiltersAdded": "All filters added",
  "service.filterBuilder.clear": "Clear",
  "service.filterBuilder.done": "Done",
  "service.filterBuilder.removeFilterLabel": "Remove {label}",
  "service.folderRow.deleteFolder": "Delete folder",
  "service.folderRow.deleteFolderAria": "Delete folder {name}",
  "service.folderRow.deleteFolderOnlyHint": "Delete only the folder: {count} file(s) move to “Unsorted”",
  "service.folderRow.deleteLabel": "Delete:",
  "service.folderRow.deleteWithFilesHint": "Permanently delete the folder along with {count} file(s)",
  "service.folderRow.folderNamePlaceholder": "Folder name …",
  "service.folderRow.folderOnly": "Folder only",
  "service.folderRow.newFolder": "New folder",
  "service.folderRow.renameFolder": "Rename folder",
  "service.folderRow.toggleHint": "Expand/collapse (double-click: rename)",
  "service.folderRow.withFiles": "With files",
  "service.page.allInFolders": "Everything filed in folders",
  "service.page.bulkCv.addMore": "Add files",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "Added {n} to {names}",
  "service.page.bulkCv.communitySubject": "{n} imported people",
  "service.page.bulkCv.desc": "Drop multiple CVs to create or update the corresponding profiles. Existing profiles are only filled where empty – nothing is overwritten.",
  "service.page.bulkCv.dupWarning": "CVs without an email create a new profile on every run. Avoid re-importing the same files.",
  "service.page.bulkCv.hint": "PDF, DOCX, images … · max. 10 MB per file · up to 25 files",
  "service.page.bulkCv.importBtn": "Import {n, plural, one {# CV} other {# CVs}}",
  "service.page.bulkCv.importPhoto": "Import photo",
  "service.page.bulkCv.importing": "Importing {done}/{total} …",
  "service.page.bulkCv.openProfile": "profile",
  "service.page.bulkCv.outcomeCreated": "New",
  "service.page.bulkCv.outcomeFailed": "couldn't import",
  "service.page.bulkCv.outcomeUpdated": "Updated",
  "service.page.bulkCv.rejected": "Some files were skipped (too large or unsupported type).",
  "service.page.bulkCv.summary": "{created} created, {updated} updated, {failed} failed",
  "service.page.bulkCv.title": "Import profiles",
  "service.page.bulkCv.tooMany": "You can import at most {max} files at once.",
  "service.page.bulkCv.willAddToCommunity": "New imports will be added to: {names}",
  "service.page.bulkCv.zone": "Drag CVs here or click to add",
  "service.page.cardCvExtractorDesc": "Parses PDF/DOCX résumés and imports positions, skills and data in a structured way.",
  "service.page.cardCvExtractorTitle": "CV extractor",
  "service.page.cardCvGeneratorDesc": "Generates a résumé from profile data - appears on the right in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV generator",
  "service.page.cardDatatransferDesc": "Exports your profile and grow data as a JSON file (GDPR Art. 20) - appears in DOCUMENTS and downloads immediately.",
  "service.page.cardDatatransferTitle": "Data transfer",
  "service.page.cardHardskillDesc": "Detects technical hard skills and tools from your profile and rates their level.",
  "service.page.cardHardskillTitle": "Hard skill analysis",
  "service.page.cardLinkedinDesc": "Imports profile, positions and skills directly from your LinkedIn account.",
  "service.page.cardLinkedinTitle": "LinkedIn import",
  "service.page.cardPowerDesc": "Identifies powers, skills and experience from free text and self-description.",
  "service.page.cardPowerTitle": "Power analysis",
  "service.page.clearSelection": "Clear selection",
  "service.page.confirmDelete": "Really delete?",
  "service.page.cvFallbackName": "CV",
  "service.page.cvNotMovable": "CV drafts cannot be moved into folders",
  "service.page.docOpening": "Document loading …",
  "service.page.documentDeleteBlocked": "This document is still used in shared posts. Remove it there first:",
  "service.page.documentsCount": "{total} documents",
  "service.page.documentsHint": "All files you have uploaded or generated through the profile services.",
  "service.page.documentsTitle": "Documents",
  "service.page.dropIntoFolder": "Drop to upload into this folder",
  "service.page.errDownload": "Download failed.",
  "service.page.errExport": "Data export failed.",
  "service.page.errExportSave": "Export could not be saved.",
  "service.page.errFolderCreate": "Folder could not be created.",
  "service.page.errFolderLimit": "You have reached the maximum of {limit} folders.",
  "service.page.errFolderDelete": "Folder could not be deleted.",
  "service.page.errFolderRename": "Folder could not be renamed.",
  "service.page.errMove": "Move failed.",
  "service.page.errNoContent": "No content available.",
  "service.page.errNotSignedInExport": "Not signed in - export not possible.",
  "service.page.errNotSignedInUpload": "Not signed in - upload not possible.",
  "service.page.errOpen": "Opening failed.",
  "service.page.errPopupBlocked": "The browser blocked opening in a new tab - please allow pop-ups for this site and click Open again.",
  "service.page.errProfileLoad": "Profile data could not be loaded.",
  "service.page.errRename": "Rename failed.",
  "service.page.errUploadDuplicate": "Upload failed. A document with this name probably already exists.",
  "service.page.error": "Error: {message}",
  "service.page.exporting": "Exporting …",
  "service.page.filterFileType": "Filetype",
  "service.page.filterPlaceholder": "Filter your available documents …",
  "service.page.filterSource": "Source",
  "service.page.folderEmpty": "Folder is empty - drag documents onto the folder tile.",
  "service.page.hardskillAnalysisTitle": "Hard skill analysis",
  "service.page.inputTitle": "Build profile",
  "service.page.maxPerFile": "max. 10 MB per file",
  "service.page.moveToFolder": "Move to folder",
  "service.page.nextPage": "Next",
  "service.page.noDocuments": "No documents",
  "service.page.noFolders": "No folders available",
  "service.page.noMatches": "No matches",
  "service.page.noMatchesInFolder": "No matches in this folder",
  "service.page.onlyRealFilesMovable": "Only real files can be moved into folders, not CV generator entries.",
  "service.page.openBlockingSharedItem": "Open shared post {number}",
  "service.page.orDragAndDrop": "Or via drag & drop",
  "service.page.outputTitle": "Export profile",
  "service.page.pageOf": "Page {page} of {total}",
  "service.page.powerAnalysisTitle": "Power analysis",
  "service.page.prevPage": "Previous",
  "service.page.removeBlockingSelection": "Remove blocking selection",
  "service.page.reset": "Reset",
  "service.page.selectedCount": "{count} selected",
  "service.page.sourceCvGenerator": "CV generator",
  "service.page.sourceUpload": "File upload",
  "service.page.unsorted": "Unsorted",
  "service.page.uploadFile": "Upload file",
  "service.page.uploading": "Uploading …",
  "service.page.viewCompact": "Compact",
  "service.page.viewPreview": "Preview",
  "service.tour.filters.desc": "Filter your documents by name, source or file type, and switch between preview and compact view.",
  "service.tour.filters.title": "Search & filter",
  "service.tour.label": "Save Documents",
  "service.tour.list.desc": "{count} documents in {folders} folders. Open a folder to see its files, drag documents between folders, and hover a row to rename, select or delete it.",
  "service.tour.list.title": "Your documents",
  "service.tour.summary": "This is your documents page: {count} documents in {folders} folders, from manual uploads to generated CVs.",
  "service.tour.upload.desc": "Upload files here (max. 10 MB each), or simply drag and drop them onto a folder or the list below.",
  "service.tour.upload.title": "Upload files",
  "settings.account.delete.button": "Delete account",
  "settings.account.delete.confirm": "Delete permanently",
  "settings.account.delete.desc": "Your account and all associated data are permanently deleted. This cannot be undone.",
  "settings.account.delete.dialogTitle": "Permanently delete account?",
  "settings.account.delete.error": "Deletion failed. Please try again.",
  "settings.account.delete.placeholder": "Full name",
  "settings.account.delete.prompt": "Type your full name to confirm:",
  "settings.account.delete.title": "Delete account",
  "settings.account.delete.zone": "Danger zone",
  "settings.eyebrow": "Platform configuration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, managed reference data, questionnaires and appearance.",
  "settings.sectionBranding": "Branding",
  "settings.sectionFragebogen": "Questionnaires",
  "settings.sectionHrPrompt": "HR prompt",
  "settings.sectionModel": "AI Model",
  "settings.sectionRoster": "Import profiles",
  "settings.sectionStammdaten": "Master data",
  "settings.sectionStyleguide": "Styleguide",
  "settings.upload.appearance.area": "Settings",
  "settings.upload.appearance.limit": "up to 16 MB",
  "settings.upload.appearance.note": "base64-inline, BFF limit",
  "settings.upload.appearance.what": "Logo & background image",
  "settings.upload.docs.area": "Save · Documents",
  "settings.upload.docs.limit": "10 MB per file",
  "settings.upload.docs.what": "File upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "All uploads are base64-encoded and routed through the BFF, which allows max. 16 MB per request. Since base64 inflates the size by about 33 %, the actual file limits sit somewhat below that.",
  "settings.upload.profile.area": "Profile",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profile photo / avatar",
  "settings.upload.shareAttach.area": "Share · Attachments",
  "settings.upload.shareAttach.limit": "up to 16 MB",
  "settings.upload.shareAttach.note": "technical ceiling (BFF)",
  "settings.upload.shareAttach.what": "File attachments on items",
  "settings.upload.shareImage.area": "Share · Items",
  "settings.upload.shareImage.limit": "5 MB per image",
  "settings.upload.shareImage.what": "Cover image",
  "share.create.attachmentsLabel": "Attachments",
  "share.create.authorLabel": "Author",
  "share.create.commentsAfterPublish": "Available after publishing.",
  "share.create.commentsLabel": "Comments",
  "share.create.createHeading": "{type, select, POST {New post} other {New project}}",
  "share.create.descriptionLabel": "Description",
  "share.create.descriptionPlaceholder": "{type, select, POST {Describe your post …} other {Describe your project …}}",
  "share.create.editHeading": "{type, select, POST {Edit post} other {Edit project}}",
  "share.create.existingAttachment": "Attachment {n}",
  "share.create.existingImage": "Image {n}",
  "share.create.eyebrowCreate": "Create",
  "share.create.eyebrowEdit": "Edit",
  "share.create.eyebrowPreview": "Preview",
  "share.create.fromDocuments": "From my documents",
  "share.create.imagesLabel": "Images",
  "share.create.loadingFiles": "loading…",
  "share.create.mainImageBadge": "Preview",
  "share.create.mainImageHint": "Set as preview image",
  "share.create.noDescription": "No description.",
  "share.create.previewButton": "Preview",
  "share.create.previewHeading": "Here's how it looks",
  "share.create.publish": "Publish",
  "share.create.publishedAtLabel": "Published on",
  "share.create.ratingLabel": "Rating",
  "share.create.shortDescriptionLabel": "Short description",
  "share.create.shortDescriptionPlaceholder": "In one sentence: what is it about?",
  "share.create.statComments": "Comments",
  "share.create.statInterested": "Interested",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Ratings",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Title",
  "share.create.titlePlaceholder": "{type, select, POST {Title of the post} other {Title of the project}}",
  "share.create.tooLarge": "Too large (max. {max} MB per file): {names}",
  "share.create.typeLabel": "Type",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Project",
  "share.create.unsupportedType": "Unsupported file type: {names}",
  "share.create.untitled": "Untitled",
  "share.docPicker.confirm": "Add {count}",
  "share.docPicker.empty": "No documents in your vault yet.",
  "share.docPicker.emptyImages": "No images in your documents yet.",
  "share.docPicker.hint": "Selected documents are attached to the post as a copy.",
  "share.docPicker.loadFailed": "Loading documents failed.",
  "share.docPicker.title": "Add from my documents",
  "share.docPicker.unnamedDocument": "Unnamed document",
  "share.itemDetail.alreadyRated": "You have already rated, tap again to change.",
  "share.itemDetail.attachmentDownloadFailed": "Download failed.",
  "share.itemDetail.attachmentOpenFailed": "Open failed.",
  "share.itemDetail.attachmentUnnamed": "Attachment",
  "share.itemDetail.attachments": "Attachments",
  "share.itemDetail.downloadAttachment": "Download {name}",
  "share.itemDetail.openAttachment": "Open {name}",
  "share.itemDetail.author": "Author",
  "share.itemDetail.commentPlaceholder": "Write a comment…",
  "share.itemDetail.comments": "Comments",
  "share.itemDetail.deleteConfirm": "Delete?",
  "share.itemDetail.error": "Error: {message}",
  "share.itemDetail.expressInterest": "Express interest",
  "share.itemDetail.imageN": "Image {n}",
  "share.itemDetail.linkedMatchTitle": "Start a new match linked to this share item",
  "share.itemDetail.loading": "loading…",
  "share.itemDetail.more": "More",
  "share.itemDetail.newMatch": "New match ↗",
  "share.itemDetail.no": "No",
  "share.itemDetail.noComments": "No comments yet, be the first.",
  "share.itemDetail.noDescription": "No description",
  "share.itemDetail.noDescriptionHint": "no content provided",
  "share.itemDetail.notFound": "Post not found",
  "share.itemDetail.publishedOn": "Published on",
  "share.itemDetail.rateYourselfTitle": "Click to rate it yourself",
  "share.itemDetail.rating": "Rating",
  "share.itemDetail.ratingClose": "close",
  "share.itemDetail.ratingOpen": "rate ›",
  "share.itemDetail.ratingsCount": "({count} ratings)",
  "share.itemDetail.send": "Send",
  "share.itemDetail.share": "Share",
  "share.itemDetail.shareWithIcon": "↗ Share",
  "share.itemDetail.signedUpWithdraw": "✓ Interested - withdraw",
  "share.itemDetail.starsAriaLabel": "{n} of 5 stars",
  "share.itemDetail.starsTitle": "{n, plural, one {# star} other {# stars}}",
  "share.itemDetail.statInterested": "Interested",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Thanks!",
  "share.itemDetail.tour.actions.desc": "Watch the item to follow it, or start a new match linked to it.",
  "share.itemDetail.tour.actions.projectDesc": "Watch the item to follow it, express interest to sign up as a participant, or start a new match linked to this project.",
  "share.itemDetail.tour.actions.title": "Get involved",
  "share.itemDetail.tour.content.desc": "Title, image gallery and full description of \"{name}\". Click the thumbnails to browse the images.",
  "share.itemDetail.tour.content.title": "The content",
  "share.itemDetail.tour.label": "Share Post",
  "share.itemDetail.tour.stats.desc": "The item's reach so far: {views} views, {pins} pins and {signUps} interested people.",
  "share.itemDetail.tour.stats.title": "How it's doing",
  "share.itemDetail.tour.summary": "You are looking at \"{name}\", a {type} from the Share community.",
  "share.itemDetail.unwatch": "✓ Watching - remove",
  "share.itemDetail.watch": "Watch",
  "share.itemDetail.yes": "Yes",
  "share.landing.carouselDiscussed": "Most comments",
  "share.landing.carouselInterest": "Most interested",
  "share.landing.carouselNew": "Newest",
  "share.landing.carouselTop": "Top rated",
  "share.landing.discoverAllPosts": "Discover all posts ↗",
  "share.landing.discoverEyebrow": "Discover",
  "share.landing.error": "Error: {message}",
  "share.landing.heroBody": "Publish projects and posts, gather interested people, feedback and reach. And discover what the community is currently building.",
  "share.landing.heroCta": "Create ↗",
  "share.landing.heroSubtitleLine1": "Show what you are working on.",
  "share.landing.heroSubtitleLine2": "Find who joins in.",
  "share.landing.loading": "loading…",
  "share.landing.myActivity": "My activity",
  "share.landing.myProjectsSection": "My projects & posts",
  "share.landing.next": "Next",
  "share.landing.noOwnPosts": "No own posts yet",
  "share.landing.noOwnPostsHint": "create a project or a post",
  "share.landing.noSharedItems": "No shared items available.",
  "share.landing.noShortDescription": "No short description.",
  "share.landing.nothingWatched": "Nothing watched or involved yet",
  "share.landing.nothingWatchedHint": "Watch projects & posts or get involved.",
  "share.landing.open": "Open ↗",
  "share.landing.previous": "Previous",
  "share.landing.share": "↗ Share",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Comments",
  "share.landing.statInterested": "Interested",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "The {count} items you are watching or signed up for, so you can get back to them quickly.",
  "share.landing.tour.activity.emptyDesc": "Items you watch or sign up for will collect here; nothing yet. Open an item and hit Watch or Express interest.",
  "share.landing.tour.activity.title": "Watched & involved",
  "share.landing.tour.carousel.desc": "Four curated top-5 lists: top rated, newest, most interested, most comments. Switch lists with the tabs; currently showing \"{featured}\". Click Open to jump into an item.",
  "share.landing.tour.carousel.title": "Discover",
  "share.landing.tour.create.desc": "Publish your own project or post here. Describe it, add images, and collect interested people.",
  "share.landing.tour.create.title": "Create something",
  "share.landing.tour.emptySummary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Your own {count} published items. 'View all' opens the full list where you can manage them.",
  "share.landing.tour.mine.emptyDesc": "Your own published items will appear here. You haven't created any yet.",
  "share.landing.tour.mine.title": "My projects & posts",
  "share.landing.tour.summary": "This is Share, the community feed where people publish projects and posts, gather interested people and feedback. Right now \"{name}\" is in the spotlight.",
  "share.landing.viewAll": "View all ↗",
  "share.landing.watchedSection": "Watched & involved",
  "share.mine.emptyHint": "create a project or a post",
  "share.mine.emptyLabel": "No own posts yet",
  "share.mine.error": "Error: {message}",
  "share.mine.eyebrow": "SHARE · My posts",
  "share.mine.filterAll": "All",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projects",
  "share.mine.subtitle": "All your projects and posts.",
  "share.mine.title": "My posts",
  "share.mine.tour.filters.desc": "Narrow the list to Projects or Posts, and change the sort order on the right.",
  "share.mine.tour.filters.title": "Filter & sort",
  "share.mine.tour.items.desc": "{count} items. Click one to open it; as the owner you can edit or delete it from its detail page.",
  "share.mine.tour.items.emptyDesc": "Nothing here yet. Create a project or a post and it will show up in this grid.",
  "share.mine.tour.items.title": "Your items",
  "share.mine.tour.label": "Share Mine",
  "share.mine.tour.summary": "These are your own posts, everything you have published on Share. You have {count} items here right now.",
  "skill.catAwareness": "Awareness & Learning",
  "skill.catImpact": "Create Impact & Influence",
  "skill.catPractical": "Practical Application & Skill Proficiency",
  "skill.desc.1": "You know basic concepts of this competency and have had first touchpoints with it, but do not yet use it practically.",
  "skill.desc.2": "You are actively building foundations in this competency and can handle first simple tasks with support and clear guidance.",
  "skill.desc.3": "You already use this competency in first practical situations and can complete simple tasks independently.",
  "skill.desc.4": "You use this competency regularly and can solve typical tasks reliably and independently.",
  "skill.desc.5": "You have deep practical experience and use this competency confidently in varied, complex, and demanding situations.",
  "skill.desc.6": "You are a recognized reference for this competency and strengthen others in applying it by effectively establishing best practices in the team or organization.",
  "skill.desc.7": "You develop forward-looking approaches for this competency and provide direction-setting impulses that lead to new standards.",
  "skill.infoLabel": "Level description",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Getting to know it & first touchpoints",
  "skill.levelTitle.2": "Focused development",
  "skill.levelTitle.3": "First practical applications",
  "skill.levelTitle.4": "Regular & reliable practical application",
  "skill.levelTitle.5": "Confident use in demanding contexts",
  "skill.levelTitle.6": "Empowering & developing others",
  "skill.levelTitle.7": "Shaping what is next & driving innovation",
  "sort.az": "A–Z",
  "sort.label": "Sort",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Newest",
  "sort.old": "Oldest",
  "sort.top": "Top rated",
  "stammdaten.details": "Details",
  "stammdaten.experience": "Work experience",
  "stammdaten.organisation": "Organisation",
  "suggestions.activities": "Suggest tasks",
  "suggestions.add": "Tap to add",
  "suggestions.addTask": "+ Add task",
  "suggestions.empty": "No suggestions found",
  "suggestions.loading": "Loading suggestions…",
  "suggestions.needJobTitle": "Enter a job title first",
  "suggestions.retry": "Try again",
  "suggestions.unavailable": "Suggestions currently unavailable",
  "topbar.help.choiceNews": "Show what's new",
  "topbar.help.choiceTour": "Start the tour",
  "topbar.help.hint": "New here? Start the guided tour of the app with this button.",
  "topbar.help.hintDismiss": "Dismiss",
  "topbar.help.hintNews": "Something has changed since your tour. This button shows you what's new.",
  "topbar.help.label": "Start the guided tour",
  "unsavedGuard.body": "You have changes that haven't been saved yet. If you leave this page, they will be lost.",
  "unsavedGuard.discard": "Discard",
  "unsavedGuard.save": "Save",
  "unsavedGuard.stay": "Stay here",
  "unsavedGuard.title": "Unsaved changes",
  "userSettings.claude.appDesc": "Add Smycles once as a connector in your Claude account, then it works across the Claude desktop app, the web app and mobile.",
  "userSettings.claude.appInternalHint": "Note: Claude connects from its own cloud, so this does not work on internal systems for now. The Smycles server has to be reachable from the public internet. Claude Code (below) works on internal systems today.",
  "userSettings.claude.appStep1": "In Claude, open Settings, then Connectors.",
  "userSettings.claude.appStep2": "Choose Add custom connector and paste the Server URL above.",
  "userSettings.claude.appStep3": "Open Advanced settings, enter the Client ID above, and leave the client secret empty.",
  "userSettings.claude.appStep4": "Add the connector, then Connect and sign in with your Smycles account.",
  "userSettings.claude.appTeamNote": "On Team and Enterprise plans an organization owner adds the connector once; everyone else only clicks Connect and signs in.",
  "userSettings.claude.appTitle": "Claude app (desktop, web and mobile)",
  "userSettings.claude.clientIdLabel": "Client ID",
  "userSettings.claude.codeDesc": "Run this command, then start Claude Code, run /mcp, choose smycles and select Authenticate. A browser window opens for the Smycles login.",
  "userSettings.claude.codeTitle": "Claude Code (for developers)",
  "userSettings.claude.commandLabel": "Command",
  "userSettings.claude.detailsTitle": "Connection details",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.intro": "Use your Smycles data and tools directly inside Claude. Claude sees exactly what you can see; you sign in with your normal Smycles account. This is separate from the assistant built into Smycles.",
  "userSettings.claude.noSecret": "No client secret is needed. Leave the secret field empty.",
  "userSettings.claude.title": "Connect Claude",
  "userSettings.claude.urlLabel": "Server URL",
  "userSettings.data.desc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). Find data transfer in your profile under \"Service\".",
  "userSettings.data.link": "Go to data transfer ↗",
  "userSettings.data.title": "Data export",
  "userSettings.email": "Email",
  "userSettings.eyebrow": "Account · Preferences",
  "userSettings.heading": "Settings",
  "userSettings.identityTitle": "Identity",
  "userSettings.intro": "Manage your account, notifications and privacy.",
  "userSettings.language": "Language",
  "userSettings.languageHint": "Also used for AI generation.",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Account",
  "userSettings.sectionConnections": "Connections",
  "userSettings.sectionData": "Data & export",
  "userSettings.tour.content.accountDesc": "Your identity (name and email), the interface language (also used for AI generation) and, at the bottom, account deletion.",
  "userSettings.tour.content.dataDesc": "Export your profile and Grow data as a JSON file (GDPR Art. 20). The button hands you over to the data transfer.",
  "userSettings.tour.content.title": "The active section",
  "userSettings.tour.label": "Settings",
  "userSettings.tour.nav.desc": "Switch between Account (identity, language, deletion) and Data & export (your GDPR data export).",
  "userSettings.tour.nav.title": "The sections",
  "userSettings.tour.summary": "These are your account settings: identity, interface language, data export and account deletion.",
  "whatsNew.v0_1": "New in Smycles: connect the Claude apps to your data. This settings page shows you how, with the MCP endpoint, the client id and a step-by-step guide.",
  "tobis.eyebrow": "Movie",
  "tobis.favorite.add": "Add to favourites",
  "tobis.favorite.remove": "Remove from favourites",
  "tobis.title": "Data sources",
  "tobis.intro": "TVmaze supplies the candidates and reports what changed; the IMDb id it carries is the bridge to OMDb, which adds ratings, votes and box office. Fetches run in the background, the log below updates on its own.",
  "tobis.notConfigured": "No database configured. Set TOBIS_DATABASE_URL in the BFF environment and run the migration.",
  "tobis.loadError": "The overview could not be loaded.",
  "tobis.notice.started": "Fetch for {source} started.",
  "tobis.notice.alreadyRunning": "A fetch for {source} is already running.",
  "tobis.notice.forbidden": "You lack the permission to trigger a fetch.",
  "tobis.notice.failed": "The fetch could not be started.",
  "tobis.never": "never",
  "tobis.status.running": "running",
  "tobis.status.ok": "ok",
  "tobis.status.partial": "partial",
  "tobis.status.failed": "failed",
  "tobis.trigger": "Fetch now",
  "tobis.kpi.records": "Records",
  "tobis.kpi.recordsSub": "current, all sources",
  "tobis.kpi.failing": "Sources failing",
  "tobis.kpi.failingSub": "of {total} sources",
  "tobis.kpi.lastRun": "Last run",
  "tobis.kpi.scheduled": "Scheduled",
  "tobis.kpi.scheduledValue": "{active}/{total}",
  "tobis.kpi.scheduledSub": "sources on a timer",
  "tobis.sources.title": "Sources",
  "tobis.sources.counts": "{current} current, {superseded} historic · last data {moment}",
  "tobis.sources.lastRun": "last run {status}, {seen} seen, {created} new",
  "tobis.sources.failedHint": "Last run failed",
  "tobis.sources.scheduled": "scheduled · next {when}",
  "tobis.sources.scheduledOff": "timer configured, currently off",
  "tobis.sources.storesAs": "counts under {target}",
  "tobis.sources.trend": "Inflow trend",
  "tobis.schedule.today": "today {time}",
  "tobis.schedule.tomorrow": "tomorrow {time}",
  "tobis.runs.title": "Fetch log",
  "tobis.runs.empty": "No fetch has run yet.",
  "tobis.runs.emptyFiltered": "No runs match this filter.",
  "tobis.runs.source": "Source",
  "tobis.runs.started": "Started",
  "tobis.runs.status": "Status",
  "tobis.runs.seen": "Seen",
  "tobis.runs.new": "New",
  "tobis.runs.changed": "Changed",
  "tobis.runs.filter.allSources": "All sources",
  "tobis.runs.filter.onlyFailedAria": "Show only failed runs",
  "tobis.runs.filter.failed": "FAILED",
  "tobis.runs.filter.all": "ALL",
  "settings.sectionTobis": "Movie",
  "nav.tobisTitles": "Titles",
  "nav.tobisPeople": "People",
  "nav.tobisLab": "Lab",
  "nav.tobisMarket": "Market",
  "tobis.titles.heading": "Titles",
  "tobis.titles.intro": "Every title loaded so far, with the rating signals that carry a purchase decision. Votes matter as much as the rating: a high score on few votes says little.",
  "tobis.titles.count": "{count} titles",
  "tobis.titles.countOfTotal": "{count} of {total} titles loaded",
  "tobis.titles.loadMore": "Load more",
  "tobis.titles.loadingMore": "Loading\u2026",
  "tobis.titles.empty": "No titles loaded yet.",
  "tobis.titles.emptyHint": "Start a fetch under Sources.",
  "tobis.titles.emptyNoImage": "No titles with a cover image match these filters.",
  "tobis.titles.emptyNoImageHint": "There are matches without a cover image.",
  "tobis.titles.removeImageFilter": "Remove cover filter",
  "tobis.titles.loading": "Searching the database…",
  "tobis.titles.searchLabel": "Search titles",
  "tobis.titles.searchPlaceholder": "Search by name",
  "tobis.view.grid": "Tiles",
  "tobis.view.compact": "Compact",
  "tobis.people.heading": "People",
  "tobis.people.intro": "Actors from the loaded cast lists. Open a name to see the filmography as a timeline.",
  "tobis.people.count": "{count} people",
  "tobis.people.countOfTotal": "{count} of {total} people loaded",
  "tobis.people.empty": "No people loaded yet.",
  "tobis.people.loading": "Searching the database…",
  "tobis.people.emptyHint": "Cast lists arrive with a TVmaze fetch.",
  "tobis.people.searchLabel": "Search people",
  "tobis.people.searchPlaceholder": "Search by name",
  "tobis.people.credits": "{count} roles",
  "tobis.person.back": "Back to people",
  "tobis.person.birthday": "Born",
  "tobis.person.country": "Country",
  "tobis.person.timeline": "Filmography",
  "tobis.person.timelineEmpty": "No roles recorded yet.",
  "tobis.person.allYears": "All years",
  "tobis.person.timelineFilterEmpty": "No roles found for this type.",
  "tobis.person.liveCreditsHeading": "Also listed at TMDB",
  "tobis.person.liveCreditsHint": "Not yet in our own catalog - fetched live from TMDB, not limited by release date.",
  "tobis.person.lowConfidence": "This merge is uncertain: the combined filmography may belong to two different people with the same name.",
  "tobis.person.asRole": "as {role}",
  "tobis.person.asSelf": "as themselves",
  "tobis.person.voice": "voice role",
  "tobis.person.sinceYear": "{year} until today",
  "tobis.person.yearRange": "{from} to {to}",
  "tobis.card.rating": "{rating} ({votes})",
  "tobis.card.noRating": "no rating",
  "tobis.card.admissionsDe": "{count} DE",
  "tobis.person.moreRoles": " and {count} more roles",
  "tobis.title.back": "Back to titles",
  "tobis.title.about": "Title",
  "tobis.title.years": "Aired",
  "tobis.title.kind": "Kind",
  "tobis.title.status": "Status",
  "tobis.title.runtime": "Runtime",
  "tobis.title.minutes": "{count} min",
  "tobis.title.network": "Network",
  "tobis.title.country": "Country",
  "tobis.title.imdb": "IMDb id",
  "tobis.title.originalTitle": "Original title",
  "tobis.title.wikidata": "Wikidata",
  "tobis.title.eidr": "EIDR",
  "tobis.title.isan": "ISAN",
  "tobis.title.signals": "Signals",
  "tobis.title.rating": "IMDb",
  "tobis.title.votes": "Votes",
  "tobis.title.tmdbScore": "TMDB",
  "tobis.title.metascore": "Metascore",
  "tobis.title.wins": "Awards",
  "tobis.title.boxOffice": "Box office (OMDb)",
  "tobis.title.budget": "Budget",
  "tobis.title.revenue": "Revenue (worldwide, TMDB)",
  "tobis.title.popularity": "Popularity",
  "tobis.title.script": "Screenplay",
  "tobis.title.scriptValue": "{scenes} scenes, {characters} roles ({source})",
  "tobis.title.admissionsDe": "DE admissions",
  "tobis.title.admissionsDeValue": "{count} ({source})",
  "tobis.title.admissionsMeasured": "measured, FFA",
  "tobis.title.admissionsEstimated": "estimated, LUMIERE",
  "tobis.title.admissionsTotal": "Admissions, total",
  "tobis.title.admissionsTotalValue": "{count} (LUMIERE, {markets} markets)",
  "tobis.admissions.modalTitle": "Admissions by market",
  "tobis.admissions.summary": "{markets, plural, one {# market} other {# markets}}, counted from {year}",
  "tobis.admissions.ffaNote": "The FFA hit list reports {count} admissions for Germany - a published settlement, and therefore the better figure for DE.",
  "tobis.admissions.disclaimer": "LUMIERE calls its figures minimum estimates; coverage varies by market and year, and outside Europe it only holds what was reported to it. Admissions before the first year of record are missing.",
  "tobis.admissions.source": "LUMIERE film page",
  "tobis.admissions.close": "Close",
  "tobis.dossier.title": "Everything we hold",
  "tobis.dossier.loading": "Collecting sources …",
  "tobis.dossier.loadError": "The sources could not be read.",
  "tobis.dossier.empty": "No source holds anything on this entry.",
  "tobis.dossier.failed": "not readable",
  "tobis.dossier.fieldCount": "{count} fields",
  "tobis.dossier.rowCount": "{count} rows",
  "tobis.dossier.allEmpty": "Every field is empty.",
  "tobis.dossier.emptyFields": "{count} further fields are empty: {names}",
  "tobis.dossier.caveatTitleYear": "Linked by title and year (±1), not by ID - this source carries no IMDb id, so a wrong match is possible.",
  "tobis.dossier.caveatName": "Linked by plain name, not by ID - namesakes end up in the same row set.",
  "tobis.dossier.caveatTitleWriter": "Linked by title and, where possible, by year or screenwriter. The match_origin column says which carried: 'title+year' and 'title+writer' are corroborated, 'title' rests on the name alone.",
  "tobis.title.cast": "Cast",
  "tobis.title.funding": "FFA funding & chart entries",
  "tobis.title.admissionsSeries": "Admissions over time (Germany)",
  "tobis.title.admissionsSeriesTotal": "Admissions, cumulative",
  "tobis.title.admissionsSeriesPeriod": "Admissions in period",
  "tobis.title.admissionsSeriesInPeriod": "{count} in this period",
  "tobis.title.admissionsSeriesRank": "chart position #{rank}",
  "tobis.title.admissionsSeriesNote": "FFA charts. These are rankings, not a full census: months in which the film left the top 100 are missing. The cumulative figure comes from the FFA and carries those gaps.",
  "tobis.title.revenueHistory": "Revenue over time (TMDB)",
  "tobis.title.revenueHistoryNote": "Worldwide gross as recorded by TMDB at each of our fetch dates. Intervals are irregular, and the figure is only as current as TMDB's editors keep it: a size class, not an official accounting figure.",
  "tobis.title.revenueHistorySource": "Source: TMDB",
  "tobis.title.fundingAmount": "{amount} €",
  "tobis.title.hitlisteLegacyEntry": "{year} ({period})",
  "tobis.title.hitlisteLegacyAdmissions": "{count} admissions",
  "tobis.title.fundingSource": "FFA funding overview (current list, not the archived filing)",
  "tobis.title.dfff": "DFFF funding project",
  "tobis.title.dfff.regie": "Director",
  "tobis.title.dfff.autor": "Writer",
  "tobis.title.dfff.darsteller": "Cast",
  "tobis.title.dfff.produzent": "Producer",
  "tobis.title.dfff.koproduzenten": "Co-producers",
  "tobis.title.dfff.verleih": "Distributor",
  "tobis.title.dfff.produktionsdienstleister": "Production service",
  "tobis.title.dfff.drehbeginn": "Shoot start",
  "tobis.title.dfff.foerderung": "DFFF grant",
  "tobis.title.dfff.zuschuss": "DFFF grant (co-financing)",
  "tobis.title.dfff.source": "DFFF project list (source)",
  "tobis.title.castEmpty": "No cast recorded.",
  "tobis.title.castFilterEmpty": "No one found for this type.",
  "tobis.title.castRoles": "{role} and {count} more",
  "tobis.person.titleCount": "Titles",
  "tobis.person.boxOffice": "Box office track record",
  "tobis.person.boxOfficeValue": "{admissions} admissions (DE), from {withData} of {total} titles",
  "tobis.person.viewOnTmdb": "View on TMDB",
  "tobis.person.awards": "Awards",
  "tobis.person.awardWon": "Won",
  "tobis.person.awardNominated": "Nominated",
  "tobis.person.awardsMore": "and {count} more",
  "tobis.person.scripts": "Screenplays",
  "tobis.person.scriptScenes": "{count} scenes",
  "tobis.sort.newest": "Newest first",
  "tobis.sort.relevance": "Relevance",
  "tobis.sort.updated": "Recently updated",
  "tobis.filter.reset": "Reset filters",
  "tobis.filter.all": "All",
  "tobis.filter.movies": "Films",
  "tobis.filter.series": "Series",
  "tobis.filter.genres": "Genres",
  "tobis.filter.languages": "Languages",
  "tobis.filter.companies": "Production company",
  "tobis.filter.distributors": "Distributor",
  "tobis.filter.year": "Year",
  "tobis.filter.yearFrom": "Year from",
  "tobis.filter.yearTo": "Year to",
  "tobis.filter.rangeSecondClick": "Second click sets the end date",
  "tobis.filter.ratingFrom": "Rating from",
  "tobis.filter.votesFrom": "Votes from",
  "tobis.filter.sources": "Sources",
  "tobis.filter.admissionsFrom": "DE admissions from",
  "tobis.filter.runtimeFrom": "Runtime from",
  "tobis.filter.runtimeValue": "{minutes} min",
  "tobis.filter.productionCountry": "Production country",
  "tobis.filter.networks": "Network",
  "tobis.filter.status": "Status",
  "tobis.filter.awardsWon": "Won award",
  "tobis.filter.awardsWonWellKnown": "Most known",
  "tobis.filter.hasScript": "Screenplay",
  "tobis.filter.hasScriptLabel": "Available",
  "tobis.filter.hasImage": "Cover",
  "tobis.filter.hasImageLabel": "Only with cover",
  "tobis.filter.identifiers": "Identifiers",
  "tobis.filter.identifierImdb": "IMDb ID",
  "tobis.filter.identifierLumiere": "LUMIERE ID",
  "tobis.filter.identifierIsan": "ISAN",
  "tobis.filter.identifierWikidata": "Wikidata",
  "tobis.filter.identifierEidr": "EIDR",
  "tobis.filter.tone": "Tone / subject",
  "tobis.filter.toneAny": "Any",
  "tobis.filter.toneAll": "All",
  "tobis.filter.toneSearch": "e.g. heist, coming-of-age …",
  "tobis.filter.toneLoading": "Searching…",
  "tobis.filter.countries": "Countries",
  "tobis.filter.age": "Age",
  "tobis.filter.ageFrom": "Age from",
  "tobis.filter.ageTo": "Age to",
  "tobis.filter.rolesFrom": "Roles from",
  "tobis.filter.source": "Source",
  "tobis.filter.sourceTvmaze": "TVmaze",
  "tobis.filter.sourceTmdb": "TMDB",
  "tobis.sort.roles": "Most roles",
  "tobis.sort.admissions": "Most admissions",
  "tobis.filter.roleType": "Type",
  "tobis.filter.roleTypeActing": "Actors",
  "tobis.filter.roleTypeDirecting": "Directing",
  "tobis.filter.roleTypeProducing": "Producing",
  "tobis.filter.roleTypeCrew": "Crew",
  "tobis.lab.heading": "Lab",
  "tobis.lab.intro": "Describe your pitch, then ask the assistant about the comparable titles it finds, e.g. which of these are comparable to a pitch, and what did they earn.",
  "tobis.lab.resultHeading": "Comparable titles",
  "tobis.lab.empty": "No comparable titles found.",
  "tobis.lab.emptyHint": "Add more detail to the pitch, or try again.",
  "tobis.lab.step.pitch": "Pitch",
  "tobis.lab.step.result": "Result",
  "tobis.lab.pitchSubtitle": "Describe your pitch on the left, then derive search criteria on the right: genres, sources, and a few keywords. You can still adjust everything by hand.",
  "tobis.lab.resultSubtitle": "One pass gathers the context behind your director, writer, and cast, then selects genuinely comparable titles and assesses potential.",
  "tobis.lab.pitchTitleLabel": "Pitch title",
  "tobis.lab.pitchTitlePlaceholder": "e.g. Working title",
  "tobis.lab.pitchShortLabel": "Logline",
  "tobis.lab.pitchShortPlaceholder": "In one sentence: what, for whom?",
  "tobis.lab.pitchDescriptionLabel": "Pitch",
  "tobis.lab.pitchDescriptionPlaceholder": "Tone, genre, cast ideas, setting, whatever defines the comparison.",
  "tobis.lab.charsCount": "{count} characters",
  "tobis.lab.hintsLabel": "Tone",
  "tobis.lab.hintsPlaceholder": "Optional: mood, atmosphere, or style notes the pitch text alone might miss.",
  "tobis.lab.requiredNote": "Required",
  "tobis.lab.requiredHint": "Before comparing, fill in: {missing}",
  "tobis.lab.criteria": "Criteria",
  "tobis.lab.aiWorking": "Working…",
  "tobis.lab.aiDeriveHint": "Matches words from the pitch against the real TMDB keyword catalogue and adds to your selection without replacing what you already picked. Also picks up comparable films named in the text. Every keyword can be removed afterwards.",
  "tobis.lab.aiFillFirstHint": "Fill in the pitch or search hints first.",
  "tobis.lab.aiGenerating": "Generating…",
  "tobis.lab.generateWithAi": "Generate with AI",
  "tobis.lab.hint": "Note",
  "tobis.lab.hintText": "Keywords only rank the theme pool with TMDB coverage; genres/languages narrow it further. Director, writer, and cast add their own filmography as separate context.",
  "tobis.lab.removeKeyword": "Remove {keyword}",
  "tobis.lab.keywordsLabel": "Keywords",
  "tobis.lab.keywordAlreadyAdded": "added",
  "tobis.lab.keywordAddPlaceholder": "Add a keyword, Enter to confirm",
  "tobis.lab.aiNoMatches": "No TMDB keywords matched this text - try rephrasing with more common genre/theme words.",
  "tobis.lab.pinnedFromText": "Named in your pitch",
  "tobis.lab.pinnedRemove": "Unpin {name}",
  "tobis.lab.askPrompt": "Of the comparable titles you found for my pitch \"{title}\"{short}, which are the strongest matches, and what did they earn (DE admissions / revenue)?",
  "tobis.lab.askAssistant": "Ask the assistant",
  "tobis.lab.contextHeading": "Context sent to the AI",
  "tobis.lab.resultsHistoryHeading": "Earlier results",
  "tobis.lab.resultsHistoryOpen": "open",
  "tobis.lab.resultsHistoryDelete": "Delete this result",
  "tobis.lab.resultsHistoryDeleteConfirmTitle": "Delete this result?",
  "tobis.lab.resultsHistoryDeleteConfirmMessage": "This cannot be undone.",
  "tobis.card.keywordMatch": "{count} keywords",
  "tobis.card.personMatch": "{count} cast/crew",
  "tobis.lab.untitledPitch": "untitled",
  "tobis.lab.compare": "Find comparables",
  "tobis.lab.regenerate": "Find again",
  "tobis.lab.exportPdf": "Export as PDF",
  "tobis.lab.exportPitchHeading": "Pitch",
  "tobis.lab.findComparablesHint": "One model call gathers filmography context for director/writer/cast, ranks a theme pool, and assesses potential.",
  "tobis.lab.findingComparables": "Starting…",
  "tobis.lab.loadingResult": "Loading…",
  "tobis.lab.tobisAlgorithm.ariaLabel": "TOBIS Algorithmus",
  "tobis.lab.tobisAlgorithm.label": "TOBIS Algorithmus",
  "tobis.lab.tobisAlgorithm.infoAriaLabel": "What the TOBIS Algorithmus does",
  "tobis.lab.tobisAlgorithm.info": "Applies Movie's fixed comparison rules instead of the filters above: only titles from the last 12 years with a German cinema release or a streaming original, and 5 to 15 comparables instead of up to 8. Overrides year from/to while active.",
  "tobis.lab.directorLabel": "Director",
  "tobis.lab.directorPlaceholder": "Search by name",
  "tobis.lab.writerLabel": "Screenwriter",
  "tobis.lab.writerPlaceholder": "Search by name",
  "tobis.lab.castLabel": "Cast",
  "tobis.lab.castPlaceholder": "Search by name",
  "tobis.lab.personRemove": "Remove {name}",
  "tobis.lab.personAdd": "Add {name}",
  "tobis.lab.personSearching": "Searching…",
  "tobis.lab.personAiToggle": "Type text, AI maps it",
  "tobis.lab.personAiPlaceholder": "e.g. lead played by an actor like Jane Doe, directed by John Smith",
  "tobis.lab.personAiButton": "Map with AI",
  "tobis.lab.personAiNoMatches": "No matches yet.",
  "tobis.lab.expectedCurrencyLabel": "Currency",
  "tobis.lab.expectedBudgetLabel": "Budget",
  "tobis.lab.expectedBudgetPlaceholder": "Optional",
  "tobis.lab.expectedRevenueLabel": "Expected worldwide revenue",
  "tobis.lab.expectedRevenuePlaceholder": "Optional",
  "tobis.lab.scriptLabel": "Script",
  "tobis.lab.scriptUploadPrompt": "Upload a script PDF (optional)",
  "tobis.lab.scriptRemove": "Remove script",
  "tobis.lab.valuation.noComparablesResolved": "No comparable titles could be matched for this run.",
  "tobis.lab.valuation.heading": "Estimated bid ceiling",
  "tobis.lab.valuation.viable": "Viable at this price",
  "tobis.lab.valuation.notViable": "Not viable at this price",
  "tobis.lab.valuation.estimateFailed": "Could not be calculated - try again.",
  "tobis.lab.valuation.comparablesUsed": "{count, plural, one {# comparable with DE admissions} other {# comparables with DE admissions}}",
  "tobis.lab.valuation.avgAdmissions": "Ø DE admissions",
  "tobis.lab.valuation.avgRevenue": "Ø revenue (worldwide)",
  "tobis.lab.valuation.avgBudget": "Ø budget",
  "tobis.lab.valuation.yourRevenue": "Your expected revenue",
  "tobis.lab.valuation.yourBudget": "Your budget",
  "tobis.lab.valuation.compRevenue": "{amount} revenue",
  "tobis.lab.valuation.compBudget": "{amount} budget",
  "tobis.lab.valuation.cinemaShare": "Cinema share",
  "tobis.lab.valuation.homeEntertainment": "Home entertainment",
  "tobis.lab.valuation.payTv": "Pay-TV",
  "tobis.lab.valuation.freeTv": "Free-TV",
  "tobis.lab.valuation.distributionSubsidy": "Distribution subsidy",
  "tobis.lab.valuation.paBudget": "P&A budget",
  "tobis.lab.valuation.internalCost": "Internal cost",
  "tobis.lab.valuation.margin": "Target margin (10%)",
  "tobis.lab.valuation.distributionHeading": "Distribution across comparables",
  "tobis.lab.valuation.distributionTooFew": "Fewer than two comparables with DE admissions - not enough for a distribution.",
  "tobis.lab.valuation.distributionRevenue": "Revenue",
  "tobis.lab.valuation.distributionPrice": "Purchase price",
  "tobis.lab.valuation.distributionMostLikely": "Most likely",
  "tobis.lab.valuation.distributionCostNote": "Cost stays fixed at {amount} across every comparable - it's a manual entry for this project, not sourced per title, so it has no curve of its own.",
  "tobis.lab.valuation.distributionMeanHint": "{count} comparables with DE admissions - the peak marks the average, not a guaranteed outcome.",
  "tobis.lab.valuation.manualHint": "No source in the catalogue for these six: enter them by hand, or leave at 0 to exclude the channel.",
  "tobis.lab.valuation.comparablesHeading": "Considered comparables",
  "tobis.lab.valuation.directorCredit": "Director: {names}",
  "tobis.lab.valuation.writerCredit": "Writer: {names}",
  "tobis.lab.valuation.streamingOriginal": "Streaming Original",
  "tobis.lab.valuation.noAdmissions": "no DE admissions",
  "tobis.lab.valuation.included": "✓ Considered - remove",
  "tobis.lab.valuation.excluded": "Consider",
  "tobis.lab.valuation.excludedPrintNote": "(excluded)",
  "tobis.lab.valuation.sourceTitle": "Source",
  "tobis.lab.valuation.origin.measured": "measured",
  "tobis.lab.valuation.origin.derived": "derived",
  "tobis.lab.valuation.origin.estimated": "estimated",
  "tobis.lab.valuation.origin.manual": "manual",
  "tobis.lab.valuation.assessmentHeading": "AI assessment",
  "tobis.lab.valuation.benchmarkInfo": "What these averages mean",
  "tobis.lab.valuation.comparablesUsedInfo": "Which comparables the calculation uses",
  "tobis.lab.valuation.contribution.calculating": "Being calculated…",
  "tobis.lab.valuation.contribution.excluded": "Currently excluded, does not affect the ceiling.",
  "tobis.lab.valuation.contribution.noAdmissions": "Counts as context only: without a German admission count and a release year there is no box office figure to derive, so this title does not move the ceiling.",
  "tobis.lab.valuation.contribution.own": "{admissions} DE admissions ({year}). On this title alone the calculation would give a ceiling of {ceiling}; the figure above is the average across all included titles.",
  "tobis.lab.valuation.formula.benchmark": "Averages across the {count} considered comparables, each over the titles that actually carry the figure. Revenue and budget are TMDB, worldwide, in dollars: they place the project in an order of magnitude and deliberately do NOT enter the bid ceiling, which only ever calculates the German cinema share. That is why a title with 190M$ worldwide can still land at a ceiling of two million euros.",
  "tobis.lab.valuation.formula.ceiling": "Revenue {revenue} − cost {cost} = subtotal {subtotal}, minus the target margin {margin}. What remains is what the title may cost at most. Model {version}.",
  "tobis.lab.valuation.formula.cinemaShare": "Per comparable: DE admissions × the average ticket price of its release year = gross box office. Take out {vat} VAT, then {ffa} FFA levy and {gema} GEMA/GVL from the net, and {share} of what remains is the distributor's share. Shown here is the average across the {count} comparables that have a DE admission count.",
  "tobis.lab.valuation.formula.comparablesUsed": "Of {considered} considered titles, {used} carry both a German admission count and a release year. Only those yield a box office figure; the rest stay in the list as context and do not move the number.",
  "tobis.lab.valuation.formula.exampleAverage": "The same for the other {others, plural, one {# comparable} other {# comparables}}; the average of those {count} amounts is the {total} above (range {min} to {max}).",
  "tobis.lab.valuation.formula.exampleHeading": "Worked example: {name}",
  "tobis.lab.valuation.formula.step.gross": "{admissions} admissions × {price} ({priceYear}) = {gross} gross",
  "tobis.lab.valuation.formula.step.levies": "− {ffa} FFA − {gema} GEMA/GVL = {afterLevies}",
  "tobis.lab.valuation.formula.step.net": "− {vat} VAT = {net} net",
  "tobis.lab.valuation.formula.step.priceSubstitute": "{year}, nearest year on record: {fromYear}",
  "tobis.lab.valuation.formula.step.share": "× {share} distributor share = {result}",
  "tobis.lab.valuation.formula.manual": "No source in the catalogue for this line: the value is typed in and enters the calculation unchanged. Left at 0 € it excludes the channel.",
  "tobis.lab.valuation.formula.margin": "{rate} of P&A budget + internal cost + subtotal ({base}). That sum equals total revenue; the form follows the appraisal guide so it stays checkable against the document.",
  "tobis.lab.valuation.formulaTitle": "How this is calculated",
  "tobis.lab.valuation.whyNoReason": "The model returned no reason for this title. It came in either as a title named in the pitch or from the theme pool.",
  "tobis.lab.valuation.whyThisTitle": "Why this title?",
  "tobis.lab.landing.intro": "Every comparison-film investigation you've started. Pick one up where you left off, or start a new one.",
  "tobis.lab.landing.yourSessions": "Your investigations",
  "tobis.lab.landing.newSession": "New investigation",
  "tobis.lab.landing.creating": "Creating…",
  "tobis.lab.landing.empty": "No investigations yet",
  "tobis.lab.landing.emptyHint": "Start one with the button above.",
  "tobis.lab.landing.updatedAt": "Updated {when}",
  "tobis.lab.session.invalidUrl": "Invalid lab session URL.",
  "tobis.lab.session.loading": "Loading…",
  "tobis.lab.session.notFound": "Investigation not found.",
  "tobis.lab.session.backToLanding": "Back to Lab",
  "tobis.lab.landing.delete": "Delete",
  "tobis.lab.landing.deleteAria": "Delete {label}",
  "tobis.lab.landing.confirmDeleteTitle": "Delete “{label}”?",
  "tobis.lab.landing.confirmDeleteMessage": "The investigation and its criteria are removed for good.",
  "tobis.market.title": "Market",
  "tobis.market.intro": "German cinema and streaming market, not tied to a single title: the ground the valuation numbers stand on.",
  "tobis.market.loadError": "The market overview could not be loaded.",
  "tobis.market.loading": "Loading market data …",
  "tobis.market.cinema.title": "FFA: cinema",
  "tobis.market.admissions": "Admissions",
  "tobis.market.revenue": "Box office",
  "tobis.market.yoy": "{change} vs. {year}",
  "tobis.market.yoyPoints": "{change} PP vs. {year}",
  "tobis.market.marketShareLatest": "German market share ({year})",
  "tobis.market.homevideoLatest": "Home video ({year})",
  "tobis.market.admissionsByYear": "Admissions per year, {from}–{to}",
  "tobis.market.revenueByYear": "Box office per year, {from}–{to}",
  "tobis.market.marketShare.title": "German film market share",
  "tobis.market.marketShare": "German market share",
  "tobis.market.germanFilmCounts": "German film releases by category, {from}–{to}",
  "tobis.market.spielfilme": "Feature films",
  "tobis.market.dokumentarfilme": "Documentaries",
  "tobis.market.koproduktionen": "Co-productions",
  "tobis.market.topFilms": "Top films",
  "tobis.market.multiplex.title": "Multiplex segment over time",
  "tobis.market.monthly.title": "Admissions by month, {from}–{to}",
  "tobis.market.correlation.title": "Admissions, box office & ticket price, indexed",
  "tobis.market.correlation.note": "Admissions (millions), box office (€) and ticket price (€) have very different scales: a dual-axis chart would distort how they actually move relative to each other. Indexed to 100 in {baseYear} instead, same starting point, comparable growth.",
  "tobis.market.infrastructure.title": "FFA cinema infrastructure over time",
  "tobis.market.infrastructure.methodBreak2025": "2025 is not directly comparable to prior years for venues, screens and seats: the source PDF changed how the cinema stock is counted (excludes drive-ins, open airs, film festivals and one-off venues from 2025 on). Ticket price is unaffected.",
  "tobis.market.venuesByYear": "Venues per year",
  "tobis.market.venues": "Venues",
  "tobis.market.screensByYear": "Screens per year",
  "tobis.market.screens": "Screens",
  "tobis.market.seatsByYear": "Seats per year",
  "tobis.market.seats": "Seats",
  "tobis.market.ticketPriceByYear": "Average ticket price per year",
  "tobis.market.ticketPrice": "Ticket price",
  "tobis.market.states.title": "Admissions by state, Germany {year}",
  "tobis.market.topOverTime": "Top 6 by {metric}, over time",
  "tobis.market.venuesByState.title": "Venues by state, Germany {year}",
  "tobis.market.screeningVenues": "Screening venues",
  "tobis.market.ticketPriceByState.title": "Average ticket price by state, Germany {year}",
  "tobis.market.cities.title": "Top cities by tickets, Germany {year}",
  "tobis.market.venues.title": "Tickets by venue, Germany 2025",
  "tobis.market.kpiExplorer.title": "FFA annual figures ({count} metrics)",
  "tobis.market.kpiExplorer.note": "Self-extracted from the FFA source PDFs, verified against known reference values.",
  "tobis.market.kpiExplorer.group.admissions": "Admissions / tickets",
  "tobis.market.kpiExplorer.group.revenue": "Box office / ticket price",
  "tobis.market.kpiExplorer.group.marketShare": "Market share",
  "tobis.market.kpiExplorer.group.population": "Population",
  "tobis.market.kpiExplorer.group.infrastructure": "Venues, screens & seats",
  "tobis.market.kpiExplorer.searchLabel": "Search metrics",
  "tobis.market.kpiExplorer.searchPlaceholder": "e.g. Eintrittspreis, Sitzplätze…",
  "tobis.market.kpiExplorer.empty": "No metric matches.",
  "tobis.market.kpiExplorer.viewGrid": "Tiles",
  "tobis.market.kpiExplorer.viewOverlay": "Overlay (indexed)",
  "tobis.market.kpiExplorer.overlayNote": "Indexed to 100 in {baseYear}, the first year with a value for every selected metric.",
  "tobis.market.kpiExplorer.overlayEmpty": "No shared year with a value for every selected metric.",
  "tobis.market.byForm": "By cinema form (regular, multiplex, drive-in…)",
  "tobis.market.bySize": "By screen count per venue",
  "tobis.market.byPlaceSize": "By town population",
  "tobis.market.bySonderform": "By special venue type, {year}",
  "tobis.market.sonderformenOverTime": "Special venue types over time",
  "tobis.market.tickets": "Tickets",
  "tobis.market.homevideo.title": "Home entertainment (aggregate)",
  "tobis.market.homevideo.note": "Market-wide revenue, not per title, use as a ratio against a comparable cinema result.",
  "tobis.market.homevideo.confidenceNote": "1990–2015 read off bar-chart labels in the source PDFs (lower confidence, cross-checked against overlapping years), 2016 onward taken directly from the report text.",
  "tobis.market.homevideo.segments": "By purchase, rental & subscription",
  "tobis.market.homevideo.kaufvideos": "Purchase (DVD/Blu-ray/EST)",
  "tobis.market.homevideo.leihvideos": "Rental (DVD/Blu-ray/TVoD)",
  "tobis.market.homevideo.svod": "Subscription (SVoD)",
  "tobis.market.homevideo.consumers": "Consumers, 2017–2025",
  "tobis.market.homevideo.sankey": "Revenue breakdown, {year}",
  "tobis.market.homevideo.sankeyNote": "Two years shown where they differ: the most detailed one (rental still broken out by format) and the most recent one available (rental DVD/Blu-ray has largely disappeared since 2023, TVoD became its own segment instead).",
  "tobis.market.homevideo.metric.kaeufer": "Buyers/renters/subscribers",
  "tobis.market.homevideo.metric.reichweite": "Reach (vs. population)",
  "tobis.market.homevideo.metric.ausgaben": "Spend per person",
  "tobis.market.homevideo.metric.intensitaet": "Purchases/rentals per person",
  "tobis.market.homevideo.genres": "Genre mix (share of revenue, all formats)",
  "tobis.market.homevideo.genresNote": "Read off stacked bar-chart labels (chart estimate). Top 4 genres shown individually, the rest bundled as \"Other\": a full 10-genre breakdown would need a colour palette, which would break this dashboard's monochrome convention.",
  "tobis.market.homevideo.genre.action": "Action",
  "tobis.market.homevideo.genre.kinder": "Kids",
  "tobis.market.homevideo.genre.drama": "Drama",
  "tobis.market.homevideo.genre.komoedie": "Comedy",
  "tobis.market.homevideo.genre.sonstige": "Other",
  "tobis.market.konsumklima.title": "Consumer climate (GfK), 2016 / 2023–2025",
  "tobis.market.konsumklima.note": "Index-point change vs. prior month, as printed in the report's key-figures box. Only 4 of 15 report years print this box with numbers; the rest either don't cover the topic, show icons without a number, or only the overall index chart.",
  "tobis.market.konsumklima.metric.konjunktur": "Economic outlook",
  "tobis.market.konsumklima.metric.einkommen": "Income expectations",
  "tobis.market.konsumklima.metric.anschaffung": "Willingness to buy",
  "tobis.market.konsumklima.metric.preis": "Price expectations",
  "tobis.market.konsumklima.metric.sparen": "Savings propensity",
  "tobis.market.streaming.title": "AGF: streaming reach",
  "tobis.market.streaming.empty": "No data for this audience.",
  "tobis.market.streaming.metric": "Metric: viewing minutes per day, averaged across the whole audience group, including people who don't use the platform at all. Not the intensity of actual users.",
  "tobis.market.streaming.sources": "Source reports:",
  "tobis.market.tv.title": "AGF: television",
  "tobis.market.tv.note": "The source page has no archive, but every collected snapshot is kept: the daily top 10 can be switched between collected days (gaps are days without a run). Monthly market share still shows the latest month only.",
  "tobis.market.tv.audienceTotal": "All viewers",
  "tobis.market.tv.audienceE1449": "Viewers 14–49",
  "tobis.market.tv.dailyTop10": "Daily top 10",
  "tobis.market.tv.byDay": "Top-10 audience per day, split by channel",
  "tobis.market.tv.viewers": "Viewers (m)",
  "tobis.market.tv.empty": "No data yet.",
  "tobis.market.tv.rank": "#",
  "tobis.market.tv.channel": "Channel",
  "tobis.market.tv.programme": "Programme",
  "tobis.market.tv.viewers": "Viewers (m)",
  "tobis.market.tv.monthlyMarketShare": "Monthly market share, {period}",
  "tobis.market.sources.document": "Source document",
  "tobis.market.sources.document2025": "Source document, 2021–2025",
  "tobis.market.sources.kinoergebnisse": "Source documents:",
  "tobis.market.sources.document2025": "Source document, 2021–2025",
  "tobis.market.sources.videoergebnisse": "Source documents:",
  "tobis.boxOfficeCheck.title": "Box office sanity check",
  "tobis.boxOfficeCheck.intro": "model.match_tconst matches box office rows that have no IMDb id by title and year, within a +/-1 year tolerance. That can in theory confuse two films with the same title released in different years (e.g. remakes). No case has been found yet, but domestic gross can never exceed worldwide gross, so a hit here is a strong sign of a wrong match.",
  "tobis.boxOfficeCheck.run": "Run check",
  "tobis.boxOfficeCheck.running": "Checking…",
  "tobis.boxOfficeCheck.forbidden": "You lack the permission to run this check.",
  "tobis.boxOfficeCheck.failed": "The check could not be run.",
  "tobis.boxOfficeCheck.clean": "No anomalies found across {total} checked rows.",
  "tobis.boxOfficeCheck.found": "{anomalies} of {total} checked rows have domestic gross higher than worldwide gross.",
  "tobis.boxOfficeCheck.column.title": "Title",
  "tobis.boxOfficeCheck.column.year": "Year",
  "tobis.boxOfficeCheck.column.domestic": "Domestic",
  "tobis.boxOfficeCheck.column.worldwide": "Worldwide"
}
